import React, {useEffect, useRef, useState} from "react";
import withAuth from "../../auth/UserRouteAuth";
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import mainNotice from "../../assets/img/mainNotice.png";
import commomHeader from "../../assets/img/commonHeader.png";
import btoragePay from "../../assets/img/btorageBooster.png";
import globalCard from "../../assets/img/globalCard.png";
import koreanPay from "../../assets/img/koreanPay.png";
import paypal from "../../assets/img/3dPaypalLogo.png";
import wechatpay from "../../assets/img/3dWechatLogo.png";
import alipay from "../../assets/img/3dAlipayLogo.png";
import nobank from "../../assets/img/3dNoBankLogo.png";

import {useTranslation} from "react-i18next";
import PaypalModal from "../../components/web/modal/PaypalModal";
import {useWebSocket} from "../../services/WebsocketContext";
import i18n from "../../i18n";
import BtorageGlobalModal from "../../components/web/modal/BtorageGlobalModal";
import BtorageKoreanModal from "../../components/web/modal/BtorageKoreanModal";
import GlobalCardModal from "../../components/web/modal/GlobalCardModal";
import KoreanPayModal from "../../components/web/modal/KoreanPayModal";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserDepChargeRenew.css";
// [결제누락 개선] 결제원장 기록 / 저장 재시도 공통 모듈
import {saveWithRetry, notifyFail, sendErrorLog, PAY_USAGE} from "../../services/PayGuard";

function UserDepChargePg() {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [memberInfo, setMemberInfo] = useState("");
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (SSAT || LCAT) {
            findMember();
        }
    }, [SSAT, LCAT])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;
            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);

    const [submitBtDisabled, setSubmitBtDisabled] = useState(false);

    const [nobankTab, setNobankTab] = useState(false);
    const [paypalTab, setPaypalTab] = useState(false);
    const [yuanTab, setYuanTab] = useState(false);
    const [btorageGlobalTab, setBtorageGlobalTab] = useState(true);

    const [nobankChargeTab, setNobankChargeTab] = useState(true);
    const [nobankRefundTab, setNobankRefundTab] = useState(false);
    const [paypalChargeTab, setPaypalChargeTab] = useState(true);
    const [paypalRefundTab, setPaypalRefundTab] = useState(false);
    const [wechatChargeTab, setWechatChargeTab] = useState(true);
    const [wechatRefundTab, setWechatRefundTab] = useState(false);
    const [aliChargeTab, setAliChargeTab] = useState(true);
    const [aliRefundTab, setAliRefundTab] = useState(false);

    const [btorageGlobalChargeTab, setBtorageGlobalChargeTab] = useState(true);
    const [btorageGlobalRefundTab, setBtorageGlobalRefundTab] = useState(false);
    const [btorageKoreanChargeTab, setBtorageKoreanChargeTab] = useState(true);
    const [btorageKoreanRefundTab, setBtorageKoreanRefundTab] = useState(false);
    const [globalCardChargeTab, setGlobalCardChargeTab] = useState(true);
    const [globalCardRefundTab, setGlobalCardRefundTab] = useState(false);
    const [koreanPayChargeTab, setKoreanPayChargeTab] = useState(true);
    const [koreanPayRefundTab, setKoreanPayRefundTab] = useState(false);

    const handleBtorageGlobalAssiTab = ((tab) => {
        if (tab === 'charge') {
            setBtorageGlobalChargeTab(true);
            setBtorageGlobalRefundTab(false);
        } else {
            setBtorageGlobalChargeTab(false);
            setBtorageGlobalRefundTab(true);
        }
    });

    const handleBtorageKoreanAssiTab = ((tab) => {
        if (tab === 'charge') {
            setBtorageKoreanChargeTab(true);
            setBtorageKoreanRefundTab(false);
        } else {
            setBtorageKoreanChargeTab(false);
            setBtorageKoreanRefundTab(true);
        }
    });

    const handleGlobalCardAssiTab = ((tab) => {
        if (tab === 'charge') {
            setGlobalCardChargeTab(true);
            setGlobalCardRefundTab(false);
        } else {
            setGlobalCardChargeTab(false);
            setGlobalCardRefundTab(true);
        }
    });

    const handleKoreanPayAssiTab = ((tab) => {
        if (tab === 'charge') {
            setKoreanPayChargeTab(true);
            setKoreanPayRefundTab(false);
        } else {
            setKoreanPayChargeTab(false);
            setKoreanPayRefundTab(true);
        }
    });

    const handlePaypalAssiTab = ((tab) => {
        if (tab === "charge") {
            setPaypalChargeTab(true);
            setPaypalRefundTab(false);
        } else {
            setPaypalChargeTab(false);
            setPaypalRefundTab(true);
        }
    })

    const handleWechatAssiTab = ((tab) => {
        if (tab === "charge") {
            setWechatChargeTab(true);
            setWechatRefundTab(false);
        } else {
            setWechatChargeTab(false);
            setWechatRefundTab(true);
        }
    })

    const handleAliAssiTab = ((tab) => {
        if (tab === "charge") {
            setAliChargeTab(true);
            setAliRefundTab(false);
        } else {
            setAliChargeTab(false);
            setAliRefundTab(true);
        }
    })

    const handleNobankAssiTab = ((tab) => {
        if (tab === "charge") {
            setNobankChargeTab(true);
            setNobankRefundTab(false);
        } else {
            setNobankChargeTab(false);
            setNobankRefundTab(true);
        }
    })


    const btorageAccount = t(`dcMdMsg`);

    // 페이팔통화 셀렉트박스
    const paypalDollar = ['USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD']
    const btorageDollar = ['USD', 'JPY']
    const [selectedDollar, setSelectedDollar] = useState('USD');


    const [dollarShow, setDollarShow] = useState(false);
    const dollarRef = useRef(null);

    const toggleDollarShow = () => {
        setDollarShow(!dollarShow);
    };

    const selectChangeDollar = (e) => {
        setSelectedDollar(e);
        setDollarShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dollarRef.current && !dollarRef.current.contains(event.target)) {
                setDollarShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getTodayFormatted = () => {
        let date = new Date();
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        setNobankChargeSendDate(`${year}${month}${day}`);
        setWechatChargeSendDate(`${year}${month}${day}`);
        setAliChargeSendDate(`${year}${month}${day}`);
    };

    useEffect(() => {
        getTodayFormatted();
    }, []);

    const formatStringWithCommas = ((numberString) => {
        const numericString = numberString.replace(/[^\d]/g, '');
        return numericString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    })

    const [fieldEmptyError, setFieldEmptyError] = useState(false);
    const closeFieldEmptyError = () => {
        setFieldEmptyError(false);
    }

    // [결제누락 개선] PG 결제는 성공했으나 예치금 충전저장이 실패한 경우 안내
    //  (예치금충전은 주문서와 무관하므로 결제실패 페이지로 이동하지 않고 안내 메세지만 띄운다)
    const [depositChargeFailMsg, setDepositChargeFailMsg] = useState(false);
    const closeDepositChargeFailMsg = () => {
        setDepositChargeFailMsg(false);
    }

    // BtoragePay(Global) 충전
    const [btorageGlobalPopupSt, setBtorageGlobalPopupSt] = useState(false);
    const [btorageGlobalChargePrice, setBtorageGlobalChargePrice] = useState('');

    const closeBtorageGlobalPopup = (() => {
        setBtorageGlobalPopupSt(false);
    })

    const handleBtorageGlobalChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageGlobalChargePrice(formattedValue);
    })

    const openBtorageGlobalPopup = (() => {
        if (!btorageGlobalChargePrice) {
            setFieldEmptyError(true);
        } else {
            setBtorageGlobalPopupSt(true);
        }
    })

    const saveBtorageGlobalCharge = ((state, payNum) => {
        saveWithRetry(() => axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'BtoragePay(Global)',
                price: Number(btorageGlobalChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: btorageGlobalChargeExPrice,
                autoPayFl: true,
                payMethod: '01',
                // [결제누락 개선] PG 결제식별번호 - 결제원장(PAY_ATTEMPT_TB)과 연결
                pgPayNum: payNum || null
            },
        }), {attempts: 3, baseDelay: 1000})
            .then(async (response) => {
                setBtorageGlobalPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch(async (error) => {
                // [결제누락 개선] PG 결제는 성공했으나 충전저장이 실패한 경우
                //  예치금충전은 주문서와 무관하므로 페이지 이동 없이 안내 메세지만 띄운다.
                console.log("예치금 충전실패 : ", error);
                setSubmitBtDisabled(false);
                if (payNum) {
                    await notifyFail({payNum: payNum, failReason: `deposit charge save failed: ${error?.message || error}`});
                    await sendErrorLog(memberInfo.id, "예치금 충전저장 실패(결제성공)",
                        `payNum: ${payNum} / ${error?.message || error}`);
                }
                setBtorageGlobalPopupSt(false);
                setDepositChargeFailMsg(true);
            })
    })

    const btorageGlobalChargeInit = (() => {
        setBtorageGlobalChargePrice('');
        setSelectedDollar('');
        setBtorageGlobalChargeExPrice(0);
    })


    // BtoragePay(Global) 환급
    const [btorageGlobalRefundPrice, setBtorageGlobalRefundPrice] = useState('');
    const [btorageGlobalRefundEmail, setBtorageGlobalRefundEmail] = useState('');

    const handleBtorageGlobalRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageGlobalRefundPrice(formattedValue);
    })
    const handleBtorageGlobalRefundEmail = ((e) => {
        setBtorageGlobalRefundEmail(e.target.value);
    })

    const saveBtorageGlobalRefund = (() => {
        if (submitBtDisabled) return;
        if (!btorageGlobalRefundPrice || !btorageGlobalRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: btorageGlobalRefundEmail,
                    price: Number(btorageGlobalRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: btorageGlobalRefundExPrice,
                    autoPayFl: false,
                    payMethod: '02'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("비토리지페이(GL) 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const btorageGlobalRefundInit = (() => {
        setBtorageGlobalRefundPrice('');
        setBtorageGlobalRefundExPrice('');
        setBtorageGlobalRefundEmail('');
    })


    // BtoragePay(Korean) 충전
    const [btorageKoreanPopupSt, setBtorageKoreanPopupSt] = useState(false);
    const [btorageKoreanChargePrice, setBtorageKoreanChargePrice] = useState('');

    const closeBtorageKoreanPopup = (() => {
        setBtorageKoreanPopupSt(false);
    })

    const handleBtorageKoreanChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageKoreanChargePrice(formattedValue);
    })

    const openBtorageKoreanPopup = (() => {
        if (!btorageKoreanChargePrice) {
            setFieldEmptyError(true);
        } else {
            setBtorageKoreanPopupSt(true);
        }
    })

    const saveBtorageKoreanCharge = ((state, payNum) => {
        saveWithRetry(() => axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'BtoragePay(Korean)',
                price: Number(btorageKoreanChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                autoPayFl: true,
                payMethod: '03',
                // [결제누락 개선] PG 결제식별번호 - 결제원장(PAY_ATTEMPT_TB)과 연결
                pgPayNum: payNum || null
            },
        }), {attempts: 3, baseDelay: 1000})
            .then(async (response) => {
                setBtorageKoreanPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch(async (error) => {
                // [결제누락 개선] PG 결제는 성공했으나 충전저장이 실패한 경우
                //  예치금충전은 주문서와 무관하므로 페이지 이동 없이 안내 메세지만 띄운다.
                console.log("예치금 충전실패 : ", error);
                setSubmitBtDisabled(false);
                if (payNum) {
                    await notifyFail({payNum: payNum, failReason: `deposit charge save failed: ${error?.message || error}`});
                    await sendErrorLog(memberInfo.id, "예치금 충전저장 실패(결제성공)",
                        `payNum: ${payNum} / ${error?.message || error}`);
                }
                setBtorageKoreanPopupSt(false);
                setDepositChargeFailMsg(true);
            })
    })

    const btorageKoreanChargeInit = (() => {
        setBtorageKoreanChargePrice('');
        setSelectedDollar('');
    })


    // BtoragePay(Korean) 환급
    const [btorageKoreanRefundPrice, setBtorageKoreanRefundPrice] = useState('');
    const [btorageKoreanRefundEmail, setBtorageKoreanRefundEmail] = useState('');

    const handleBtorageKoreanRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setBtorageKoreanRefundPrice(formattedValue);
    })
    const handleBtorageKoreanRefundEmail = ((e) => {
        setBtorageKoreanRefundEmail(e.target.value);
    })

    const saveBtorageKoreanRefund = (() => {
        if (submitBtDisabled) return;
        if (!btorageKoreanRefundPrice || !btorageKoreanRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: btorageGlobalRefundEmail,
                    price: Number(btorageKoreanRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    autoPayFl: false,
                    payMethod: '04'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("비토리지페이(KR) 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const btorageKoreanRefundInit = (() => {
        setBtorageKoreanRefundPrice('');
        setBtorageKoreanRefundEmail('');
    })


    // GlobalCard 충전
    const [globalCardPopupSt, setGlobalCardPopupSt] = useState(false);
    const [globalCardChargePrice, setGlobalCardChargePrice] = useState('');

    const closeGlobalCardPopup = (() => {
        setGlobalCardPopupSt(false);
    })

    const handleGlobalCardChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setGlobalCardChargePrice(formattedValue);
    })

    const openGlobalCardPopup = (() => {
        if (!globalCardChargePrice) {
            setFieldEmptyError(true);
        } else {
            setGlobalCardPopupSt(true);
        }
    })

    const saveGlobalCardCharge = ((state, payNum) => {
        saveWithRetry(() => axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'GlobalCard',
                price: Number(globalCardChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: globalCardChargeExPrice,
                autoPayFl: true,
                payMethod: '05',
                // [결제누락 개선] PG 결제식별번호 - 결제원장(PAY_ATTEMPT_TB)과 연결
                pgPayNum: payNum || null
            },
        }), {attempts: 3, baseDelay: 1000})
            .then(async (response) => {
                setGlobalCardPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch(async (error) => {
                // [결제누락 개선] PG 결제는 성공했으나 충전저장이 실패한 경우
                //  예치금충전은 주문서와 무관하므로 페이지 이동 없이 안내 메세지만 띄운다.
                console.log("예치금 충전실패 : ", error);
                setSubmitBtDisabled(false);
                if (payNum) {
                    await notifyFail({payNum: payNum, failReason: `deposit charge save failed: ${error?.message || error}`});
                    await sendErrorLog(memberInfo.id, "예치금 충전저장 실패(결제성공)",
                        `payNum: ${payNum} / ${error?.message || error}`);
                }
                setGlobalCardPopupSt(false);
                setDepositChargeFailMsg(true);
            })
    })

    const globalCardChargeInit = (() => {
        setGlobalCardChargePrice('');
        setSelectedDollar('');
        setGlobalCardChargeExPrice(0);
    })


    // GlobalCard 환급
    const [globalCardRefundPrice, setGlobalCardRefundPrice] = useState('');
    const [globalCardRefundEmail, setGlobalCardRefundEmail] = useState('');

    const handleGlobalCardRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setGlobalCardRefundPrice(formattedValue);
    })
    const handleGlobalCardRefundEmail = ((e) => {
        setGlobalCardRefundEmail(e.target.value);
    })

    const saveGlobalCardRefund = (() => {
        if (submitBtDisabled) return;
        if (!globalCardRefundPrice || !globalCardRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: globalCardRefundEmail,
                    price: Number(globalCardRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: globalCardRefundExPrice,
                    autoPayFl: false,
                    payMethod: '06'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("글로벌카드 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const globalCardRefundInit = (() => {
        setGlobalCardRefundPrice('');
        setGlobalCardRefundExPrice('');
        setGlobalCardRefundEmail('');
    })


    // KoreanPay 충전
    const [koreanPayPopupSt, setKoreanPayPopupSt] = useState(false);
    const [koreanPayChargePrice, setKoreanPayChargePrice] = useState('');

    const closeKoreanPayPopup = (() => {
        setKoreanPayPopupSt(false);
    })

    const handleKoreanPayChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setKoreanPayChargePrice(formattedValue);
    })

    const openKoreanPayPopup = (() => {
        if (!koreanPayChargePrice) {
            setFieldEmptyError(true);
        } else {
            setKoreanPayPopupSt(true);
        }
    })

    const saveKoreanPayCharge = ((state, payNum) => {
        saveWithRetry(() => axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'KoreanPay',
                price: Number(koreanPayChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                autoPayFl: true,
                payMethod: '07',
                // [결제누락 개선] PG 결제식별번호 - 결제원장(PAY_ATTEMPT_TB)과 연결
                pgPayNum: payNum || null
            },
        }), {attempts: 3, baseDelay: 1000})
            .then(async (response) => {
                setKoreanPayPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch(async (error) => {
                // [결제누락 개선] PG 결제는 성공했으나 충전저장이 실패한 경우
                //  예치금충전은 주문서와 무관하므로 페이지 이동 없이 안내 메세지만 띄운다.
                console.log("예치금 충전실패 : ", error);
                setSubmitBtDisabled(false);
                if (payNum) {
                    await notifyFail({payNum: payNum, failReason: `deposit charge save failed: ${error?.message || error}`});
                    await sendErrorLog(memberInfo.id, "예치금 충전저장 실패(결제성공)",
                        `payNum: ${payNum} / ${error?.message || error}`);
                }
                setKoreanPayPopupSt(false);
                setDepositChargeFailMsg(true);
            })
    })

    const koreanPayChargeInit = (() => {
        setKoreanPayChargePrice('');
        setSelectedDollar('');
    })


    // KoreanPay 환급
    const [koreanPayRefundPrice, setKoreanPayRefundPrice] = useState('');
    const [koreanPayRefundEmail, setKoreanPayRefundEmail] = useState('');

    const handleKoreanPayRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setKoreanPayRefundPrice(formattedValue);
    })
    const handleKoreanPayRefundEmail = ((e) => {
        setKoreanPayRefundEmail(e.target.value);
    })

    const saveKoreanPayRefund = (() => {
        if (submitBtDisabled) return;
        if (!koreanPayRefundPrice || !koreanPayRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: koreanPayRefundEmail,
                    price: Number(koreanPayRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    autoPayFl: false,
                    payMethod: '08'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("코리안페이 환불실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const koreanPayRefundInit = (() => {
        setKoreanPayRefundPrice('');
        setKoreanPayRefundEmail('');
    })


    // 페이팔충전
    const [paypalPopupSt, setPaypalPopupSt] = useState(false);
    const [paypalChargePrice, setPaypalChargePrice] = useState('');

    const paypalPopupClose = (() => {
        setPaypalPopupSt(false);
    })

    const handlePaypalChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setPaypalChargePrice(formattedValue);
    })

    const openPaypalPopup = (() => {
        if (!paypalChargePrice) {
            setFieldEmptyError(true);
        } else {
            setPaypalPopupSt(true);
        }
    })

    const savePaypalCharge = ((state, payNum) => {
        saveWithRetry(() => axios({
            method: 'post',
            url: '/member/saveDepConfirmInfo',
            data: {
                userNm: memberInfo.userName,
                userId: memberInfo.id,
                name: memberInfo.userName,
                account: 'Paypal',
                price: Number(paypalChargePrice.replace(/,/g, "")),
                chargeFl: true,
                sendDate: nobankChargeSendDate,
                status: '1', // API response.ok면 '1' 그대로 완료
                currency: selectedDollar,
                dollarPrice: paypalChargeExPrice,
                autoPayFl: true,
                payMethod: '09',
                // [결제누락 개선] PG 결제식별번호 - 결제원장(PAY_ATTEMPT_TB)과 연결
                pgPayNum: payNum || null
            },
        }), {attempts: 3, baseDelay: 1000})
            .then(async (response) => {
                setPaypalPopupSt(false);
                saveDepositAlarmData(response.data);
                navigate("/UserDepChargeHistoryPg")
            })
            .catch(async (error) => {
                // [결제누락 개선] PG 결제는 성공했으나 충전저장이 실패한 경우
                //  예치금충전은 주문서와 무관하므로 페이지 이동 없이 안내 메세지만 띄운다.
                console.log("예치금 충전실패 : ", error);
                setSubmitBtDisabled(false);
                if (payNum) {
                    await notifyFail({payNum: payNum, failReason: `deposit charge save failed: ${error?.message || error}`});
                    await sendErrorLog(memberInfo.id, "예치금 충전저장 실패(결제성공)",
                        `payNum: ${payNum} / ${error?.message || error}`);
                }
                setPaypalPopupSt(false);
                setDepositChargeFailMsg(true);
            })
    })

    const paypalChargeInit = (() => {
        setPaypalChargePrice('');
        setSelectedDollar('');
        setPaypalChargeExPrice('');
        setPaypalChargeExPrice(0);
    })


    // 페이팔환급
    const [paypalRefundPrice, setPaypalRefundPrice] = useState('');
    const [paypalRefundEmail, setPaypalRefundEmail] = useState('');

    const handlePaypalRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setPaypalRefundPrice(formattedValue);
    })
    const handlePaypalRefundEmail = ((e) => {
        setPaypalRefundEmail(e.target.value);
    })

    const savePaypalRefund = (() => {
        if (submitBtDisabled) return;
        if (!paypalRefundPrice || !paypalRefundEmail) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: paypalRefundEmail,
                    price: Number(paypalRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: selectedDollar,
                    dollarPrice: paypalRefundExPrice,
                    autoPayFl: false,
                    payMethod: '10'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("페이팔 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const paypalRefundInit = (() => {
        setPaypalRefundPrice('');
        setPaypalRefundExPrice('');
        setPaypalRefundEmail('');
    })


    // 위챗충전
    const [wechatChargePrice, setWechatChargePrice] = useState('');
    const [wechatChargeSendId, setWechatChargeSendId] = useState('');
    const [wechatChargeSendDate, setWechatChargeSendDate] = useState('');

    const handleWechatChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setWechatChargePrice(formattedValue);
    })
    const handleWechatChargeSendId = ((e) => {
        setWechatChargeSendId(e.target.value);
    })
    const handleWechatChargeSendDate = ((e) => {
        setWechatChargeSendDate(e.target.value);
    })

    const saveWechatCharge = (() => {
        if (submitBtDisabled) return;
        if (!wechatChargePrice || !wechatChargeSendId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: wechatChargeSendId,
                    account: btorageAccount,
                    price: Number(wechatChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: wechatChargeSendDate,
                    status: '0',
                    currency: "CNY",
                    dollarPrice: wechatChargeExPrice,
                    autoPayFl: false,
                    payMethod: '11'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("위챗페이 충전실패")
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const wechatChargeInit = (() => {
        setWechatChargePrice('');
        setWechatChargeSendId('');
        setWechatChargeSendDate('');
    })

    // 위챗환급
    const [wechatRefundPrice, setWechatRefundPrice] = useState('');
    const [wechatRefundId, setWechatRefundId] = useState('');

    const handleWechatRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setWechatRefundPrice(formattedValue);
    })
    const handleWechatRefundId = ((e) => {
        setWechatRefundId(e.target.value);
    })

    const saveWechatRefund = (() => {
        if (submitBtDisabled) return;
        if (!wechatRefundPrice || !wechatRefundId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: wechatRefundId,
                    price: Number(wechatRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: "CNY",
                    dollarPrice: wechatRefundExPrice,
                    autoPayFl: false,
                    payMethod: '12'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("위챗페이 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const wechatRefundInit = (() => {
        setWechatRefundPrice('');
        setWechatRefundId('');
    })


    // 알리충전
    const [aliChargePrice, setAliChargePrice] = useState('');
    const [aliChargeSendId, setAliChargeSendId] = useState('');
    const [aliChargeSendDate, setAliChargeSendDate] = useState('');

    const handleAliChargePrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setAliChargePrice(formattedValue);
    })
    const handleAliChargeSendId = ((e) => {
        setAliChargeSendId(e.target.value);
    })
    const handleAliChargeSendDate = ((e) => {
        setAliChargeSendDate(e.target.value);
    })

    const saveAliCharge = (() => {
        if (submitBtDisabled) return;
        if (!aliChargePrice || !aliChargeSendId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: aliChargeSendId,
                    account: btorageAccount,
                    price: Number(aliChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: aliChargeSendDate,
                    status: '0',
                    currency: "CNY",
                    dollarPrice: aliChargeExPrice,
                    autoPayFl: false,
                    payMethod: '13'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("알리페이 충전실패")
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const aliChargeInit = (() => {
        setAliChargePrice('');
        setAliChargeSendId('');
        setAliChargeSendDate('');
    })

    // 알리환급
    const [aliRefundPrice, setAliRefundPrice] = useState('');
    const [aliRefundId, setAliRefundId] = useState('');

    const handleAliRefundPrice = ((e) => {
        const formattedValue = formatNumber(e.target.value);
        setAliRefundPrice(formattedValue);
    })
    const handleAliRefundId = ((e) => {
        setAliRefundId(e.target.value);
    })

    const saveAliRefund = (() => {
        if (submitBtDisabled) return;
        if (!aliRefundPrice || !aliRefundId) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: '',
                    account: aliRefundId,
                    price: Number(aliRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    sendDate: '',
                    status: '0',
                    currency: "CNY",
                    dollarPrice: aliRefundExPrice,
                    autoPayFl: false,
                    payMethod: '14'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("알리페이 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const aliRefundInit = (() => {
        setAliRefundPrice('');
        setAliRefundId('');
    })


    // 무통장충전
    const [nobankChargePrice, setNobankChargePrice] = useState('');
    const [nobankChargeSendNm, setNobankChargeSendNm] = useState('');
    const [nobankChargeSendDate, setNobankChargeSendDate] = useState('');

    const handleNobankChargePrice = ((e) => {
        const {value} = e.target;
        const formattedValue = formatStringWithCommas(value);
        setNobankChargePrice(formattedValue);
    })
    const handleNobankChargeSendNm = ((e) => {
        setNobankChargeSendNm(e.target.value);
    })
    const handleNobankChargeSendDate = ((e) => {
        setNobankChargeSendDate(e.target.value);
    })

    const saveNobankCharge = (() => {
        if (submitBtDisabled) return;
        if (!nobankChargePrice || !nobankChargeSendNm) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: nobankChargeSendNm,
                    account: btorageAccount,
                    price: Number(nobankChargePrice.replace(/,/g, "")),
                    chargeFl: true,
                    sendDate: nobankChargeSendDate,
                    status: '0',
                    autoPayFl: false,
                    payMethod: '15'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("무통장입금 충전실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const nobankChargeInit = (() => {
        setNobankChargePrice('');
        setNobankChargeSendNm('');
        setNobankChargeSendDate('');
    })


    // 무통장환급
    const [nobankRefundPrice, setNobankRefundPrice] = useState('');
    const [nobankRefundNm, setNobankRefundNm] = useState('');
    const [nobankRefundBankNm, setNobankRefundBankNm] = useState('');
    const [nobankRefundAccount, setNobankRefundAccount] = useState('');

    const handleNobankRefundPrice = ((e) => {
        const {value} = e.target;
        const formattedValue = formatStringWithCommas(value);
        setNobankRefundPrice(formattedValue);
    })
    const handleNobankRefundNm = ((e) => {
        setNobankRefundNm(e.target.value);
    })
    const handleNobankRefundBankNm = ((e) => {
        setNobankRefundBankNm(e.target.value);
    })
    const handleNobankRefundAccount = ((e) => {
        setNobankRefundAccount(e.target.value);
    })

    const saveNobankRefund = (() => {
        if (submitBtDisabled) return;
        if (!nobankRefundPrice || !nobankRefundNm || !nobankRefundBankNm || !nobankRefundAccount) {
            setFieldEmptyError(true);
            return;
        }
        try {
            axios({
                method: 'post',
                url: '/member/saveDepConfirmInfo',
                data: {
                    userNm: memberInfo.userName,
                    userId: memberInfo.id,
                    name: nobankRefundNm,
                    account: nobankRefundBankNm + nobankRefundAccount,
                    price: Number(nobankRefundPrice.replace(/,/g, "")),
                    chargeFl: false,
                    status: '0',
                    autoPayFl: false,
                    payMethod: '16'
                },
            })
                .then(async (response) => {
                    saveDepositAlarmData(response.data);
                    navigate("/UserDepChargeHistoryPg")
                })
                .catch(() => {
                    console.log("무통장입금 환급실패")
                    setSubmitBtDisabled(false);
                })
        } catch (error) {
            setSubmitBtDisabled(false);
        } finally {
            setSubmitBtDisabled(false);
        }
    })

    const nobankRefundInit = (() => {
        setNobankRefundPrice('');
        handleNobankRefundNm('');
        handleNobankRefundBankNm('');
        handleNobankRefundAccount('');
    })

    const formatNumber = (value) => {
        // 숫자 외의 모든 문자를 제거
        const number = value.replace(/[^\d]/g, "");
        // 세자리 수마다 콤마를 찍어서 반환
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    const saveDepositAlarmData = ((depositData) => {
        // [결제누락 개선 - 중복충전 방지] 이미 충전이 끝난 건을 그대로 돌려받은 응답이면
        //  관리자 알림만 중복 생성되므로 재발송하지 않는다.
        if (depositData && depositData.duplicatedFl) {
            console.log("이미 처리된 충전건이라 알림을 재발송하지 않습니다.");
            return;
        }
        axios({
            method: 'post',
            url: '/order/saveDepositData',
            headers: {
                Authorization: LCAT ? LCAT : SSAT,
                'Content-Type': 'application/json',
            },
            data: depositData
        })
            .then(async () => {
                await stompClient.send("/app/depConfirmAlarm", {}, JSON.stringify({sendFl: true}));
            })
            .catch((error) => {
                console.log("알림데이터 저장실패 : ", error)
            })
    })

    const [usdExrInfo, setUsdExrInfo] = useState([]);
    const [paypalChargeExPrice, setPaypalChargeExPrice] = useState(0);
    const [paypalRefundExPrice, setPaypalRefundExPrice] = useState(0);
    const [wechatChargeExPrice, setWechatChargeExPrice] = useState(0);
    const [wechatRefundExPrice, setWechatRefundExPrice] = useState(0);
    const [aliChargeExPrice, setAliChargeExPrice] = useState(0);
    const [aliRefundExPrice, setAliRefundExPrice] = useState(0);

    const [btorageGlobalChargeExPrice, setBtorageGlobalChargeExPrice] = useState(0);
    const [btorageGlobalRefundExPrice, setBtorageGlobalRefundExPrice] = useState(0);
    const [globalCardChargeExPrice, setGlobalCardChargeExPrice] = useState(0);
    const [globalCardRefundExPrice, setGlobalCardRefundExPrice] = useState(0);

    const selectedAllExrInfo = (() => {
        axios({
            method: 'get',
            url: '/paypal/selectedAllExrInfo/',
        })
            .then((response) => {
                setUsdExrInfo(response.data)
            })
            .catch(() => {
                console.log("환율조회실패")
            })
    })

    useEffect(() => {
        selectedAllExrInfo();
    }, [])

    const currentLanguage = i18n.language || 'ko';
    const moveToPaypalFaq = (() => {
        let seqNum;
        switch (currentLanguage) {
            case 'en':
                seqNum = "53"
                break;
            case 'ja':
                seqNum = "54"
                break;
            case 'zh':
                seqNum = "55"
                break;
            case 'id':
                seqNum = "56"
                break;
            default:
                seqNum = "52"
        }
        navigate(`/UserFaqDtPg/${seqNum}`)
    })

    const moveToYuanFaq = (() => {
        let seqNum;
        switch (currentLanguage) {
            case 'en':
                seqNum = "96"
                break;
            case 'ja':
                seqNum = "97"
                break;
            case 'zh':
                seqNum = "98"
                break;
            case 'id':
                seqNum = "99"
                break;
            default:
                seqNum = "95"
        }
        navigate(`/UserFaqDtPg/${seqNum}`)
    })

    const depositPayMethods = [
        {
            label: "Global",
            value: "btorageGlobal",
            logo: btoragePay,
        },
        {
            label: "Korean",
            value: "btorageKorean",
            logo: btoragePay,
        },
        {
            label: "GlobalCard",
            value: "globalCard",
            logo: globalCard,
        },
        {
            label: "KoreanPay",
            value: "koreanPay",
            logo: koreanPay,
        },
        {
            label: "Paypal",
            value: "paypal",
            logo: paypal,
        },
        {
            label: "WechatPay",
            value: "wechatpay",
            logo: wechatpay,
        },
        {
            label: "AliPay",
            value: "alipay",
            logo: alipay,
        },
        {
            label: "Remittance",
            value: "nobank",
            logo: nobank,
        },
    ];

    const [selected, setSelected] = useState(depositPayMethods[0]?.value);

    const handleSelect = (method) => {
        setSelected(method.value);
    };

    const calculateLastForPrice = () => {
        const btorageGlobalTab = selected === "btorageGlobal";
        const globalCardTab = selected === "globalCard";
        const paypalTab = selected === "paypal";
        const wechatpayTab = selected === "wechatpay";
        const alipayTab = selected === "alipay";

        // 1. 선택된 탭에 따라 기준 통화(Target Currency) 결정
        // 알리페이나 위챗페이일 경우 'CNY' 적용, 그 외에는 기존 selectedDollar 적용
        // (주의: 'CNY' 코드는 실제 usdExrInfo 데이터에 들어있는 위안화 코드에 맞게 수정하세요 예: 'RMB')
        const targetCurrency = (wechatpayTab || alipayTab) ? 'CNY' : selectedDollar;

        if (targetCurrency && usdExrInfo.length > 0) {
            // 2. usdExInfo 대신 동적으로 결정된 targetCurrency를 기준으로 환율 정보 탐색
            const targetExInfo = usdExrInfo.find(info => info.curPrice === targetCurrency);
            let numericFinalPayExpense;

            if (btorageGlobalTab && btorageGlobalChargeTab) {
                numericFinalPayExpense = parseFloat(btorageGlobalChargePrice.replace(/,/g, ''));
            } else if (btorageGlobalTab && btorageGlobalRefundTab) {
                numericFinalPayExpense = parseFloat(btorageGlobalRefundPrice.replace(/,/g, ''));
            } else if (globalCardTab && globalCardChargeTab) {
                numericFinalPayExpense = parseFloat(globalCardChargePrice.replace(/,/g, ''));
            } else if (globalCardTab && globalCardRefundTab) {
                numericFinalPayExpense = parseFloat(globalCardRefundPrice.replace(/,/g, ''));
            } else if (paypalTab && paypalChargeTab) {
                numericFinalPayExpense = parseFloat(paypalChargePrice.replace(/,/g, ''));
            } else if (paypalTab && paypalRefundTab) {
                numericFinalPayExpense = parseFloat(paypalRefundPrice.replace(/,/g, ''));
            } else if (wechatpayTab && wechatChargeTab) {
                numericFinalPayExpense = parseFloat(wechatChargePrice.replace(/,/g, ''));
            } else if (wechatpayTab && wechatRefundTab) {
                numericFinalPayExpense = parseFloat(wechatRefundPrice.replace(/,/g, ''));
            } else if (alipayTab && aliChargeTab) {
                numericFinalPayExpense = parseFloat(aliChargePrice.replace(/,/g, ''));
            } else if (alipayTab && aliRefundTab) {
                numericFinalPayExpense = parseFloat(aliRefundPrice.replace(/,/g, ''));
            }

            // 금액(50,000) / (환율(1333.14) - 요율(9.1%)) = 41.26usd
            // 3. usdExInfo 객체명들을 targetExInfo로 모두 교체
            if (!isNaN(numericFinalPayExpense) && targetExInfo) {
                const payRateAsRatio = targetExInfo.payRate / 100;
                const newLastForPrice = numericFinalPayExpense / (targetExInfo.payExr - (targetExInfo.payExr * payRateAsRatio));

                if (btorageGlobalTab && btorageGlobalChargeTab) {
                    setBtorageGlobalChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (btorageGlobalTab && btorageGlobalRefundTab) {
                    setBtorageGlobalRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (globalCardTab && globalCardChargeTab) {
                    setGlobalCardChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (globalCardTab && globalCardRefundTab) {
                    setGlobalCardRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (paypalTab && paypalChargeTab) {
                    setPaypalChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (paypalTab && paypalRefundTab) {
                    setPaypalRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (wechatpayTab && wechatChargeTab) {
                    setWechatChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (wechatpayTab && wechatRefundTab) {
                    setWechatRefundExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (alipayTab && aliChargeTab) {
                    setAliChargeExPrice(Number(newLastForPrice.toFixed(2)));
                } else if (alipayTab && aliRefundTab) {
                    setAliRefundExPrice(Number(newLastForPrice.toFixed(2)));
                }
            }
        }
    }

    useEffect(() => {
        calculateLastForPrice();
    }, [
        selectedDollar,
        selected,
        usdExrInfo,
        btorageGlobalChargePrice, btorageGlobalRefundPrice,
        globalCardChargePrice, globalCardRefundPrice,
        paypalChargePrice, paypalRefundPrice,
        wechatChargePrice, wechatRefundPrice,
        aliChargePrice, aliRefundPrice
    ]);





    return (
        <div className="dc-scope" data-theme={theme}>
            <div className="display-flex just-cont-center align-center">
                <div className="wd-50pc dc-wrap">
                    <div className="display-flex ht-60 just-cont-sb">
                        <div style={{display: "flex", alignItems: "flex-start", padding: "10px 0"}}>
                            <img className="wd-25 ht-25" src={commomHeader} alt="header"/>
                            <p className="font-s-20 m-l-10 font-t-title font-c-default">{t(`hdSMenu5`)}</p>
                        </div>
                        <p className="font-s-14 font-t-cont m-t-20 c-point"
                           onClick={() => navigate("/UserDepChargeHistoryPg")}
                           style={{color: "#97B2E4"}}>{t('dcHistory')}</p>
                    </div>

                    {/*상단 결제수단버튼*/}
                    <div className="dc-methods" style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "16px",
                        padding: "16px 0",
                    }}>
                        {depositPayMethods.map((method) => (
                            <div
                                key={method.value}
                                className="dc-method-card"
                                onClick={() => handleSelect(method)}
                                style={{
                                    background: "var(--dc-card)",
                                    border: selected === method.value ? "2px solid var(--up-brand)" : "1px solid var(--up-border)",
                                    borderRadius: 12,
                                    boxShadow: selected === method.value ? "var(--dc-card-sel-shadow)" : "none",
                                    transition: "border 0.2s, box-shadow 0.2s, transform 0.2s",
                                    padding: "10px 0",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    minWidth: 0,
                                }}
                            >
                                {/* 로고영역 */}
                                <div
                                    style={{
                                        width: 36,
                                        height: 36,
                                        background: method.logoBg,
                                        borderRadius: 8,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginLeft: 6,
                                    }}
                                >
                                    <img
                                        src={method.logo}
                                        alt={method.label}
                                        style={{
                                            width: 28,
                                            height: 28,
                                            objectFit: "contain",
                                            borderRadius: 6,
                                        }}
                                    />
                                </div>
                                {/* 결제수단 명칭 */}
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: selected === method.value ? 600 : 400,
                                        color: selected === method.value ? "var(--up-brand-strong)" : "var(--up-text)",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                        {method.label}
                    </span>
                            </div>
                        ))}
                    </div>

                    <div className="font-t-cont dc-panel" style={{
                        minHeight: "300px",
                        border: "solid 1px var(--up-border)",
                        marginTop: "20px",
                        padding: "10px 10px 20px 10px"
                    }}>
                        {
                            selected === "btorageGlobal" ?
                                <div className="user-center ht-60">
                                    <div className="user-center wd-80"
                                         onClick={() => handleBtorageGlobalAssiTab('charge')}>
                                        <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                           style={{borderBottom: btorageGlobalChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                    </div>
                                    <div className="user-center wd-80"
                                         onClick={() => handleBtorageGlobalAssiTab('refund')}>
                                        <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                           style={{borderBottom: btorageGlobalRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                    </div>
                                </div>
                                :
                                selected === "btorageKorean" ?
                                    <div className="user-center ht-60">
                                        <div className="user-center wd-80"
                                             onClick={() => handleBtorageKoreanAssiTab('charge')}>
                                            <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                               style={{borderBottom: btorageKoreanChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                        </div>
                                        <div className="user-center wd-80"
                                             onClick={() => handleBtorageKoreanAssiTab('refund')}>
                                            <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                               style={{borderBottom: btorageKoreanRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                        </div>
                                    </div>
                                    :
                                    selected === "globalCard" ?
                                        <div className="user-center ht-60">
                                            <div className="user-center wd-80"
                                                 onClick={() => handleGlobalCardAssiTab('charge')}>
                                                <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                   style={{borderBottom: globalCardChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                            </div>
                                            <div className="user-center wd-80"
                                                 onClick={() => handleGlobalCardAssiTab('refund')}>
                                                <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                   style={{borderBottom: globalCardRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                            </div>
                                        </div>
                                        :
                                        selected === "koreanPay" ?
                                            <div className="user-center ht-60">
                                                <div className="user-center wd-80"
                                                     onClick={() => handleKoreanPayAssiTab('charge')}>
                                                    <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                       style={{borderBottom: koreanPayChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                                </div>
                                                <div className="user-center wd-80"
                                                     onClick={() => handleKoreanPayAssiTab('refund')}>
                                                    <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                       style={{borderBottom: koreanPayRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                                </div>
                                            </div>
                                            :
                                            selected === "paypal" ?
                                                <div className="user-center ht-60">
                                                    <div className="user-center wd-80"
                                                         onClick={() => handlePaypalAssiTab('charge')}>
                                                        <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                           style={{borderBottom: paypalChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                                    </div>
                                                    <div className="user-center wd-80"
                                                         onClick={() => handlePaypalAssiTab('refund')}>
                                                        <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                           style={{borderBottom: paypalRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                                    </div>
                                                </div>
                                                :
                                                selected === "wechatpay" ?
                                                    <div className="user-center ht-60">
                                                        <div className="user-center wd-80"
                                                             onClick={() => handleWechatAssiTab('charge')}>
                                                            <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                               style={{borderBottom: wechatChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                                        </div>
                                                        <div className="user-center wd-80"
                                                             onClick={() => handleWechatAssiTab('refund')}>
                                                            <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                               style={{borderBottom: wechatRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                                        </div>
                                                    </div>
                                                    :
                                                    selected === "alipay" ?
                                                        <div className="user-center ht-60">
                                                            <div className="user-center wd-80"
                                                                 onClick={() => handleAliAssiTab('charge')}>
                                                                <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                                   style={{borderBottom: aliChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                                            </div>
                                                            <div className="user-center wd-80"
                                                                 onClick={() => handleAliAssiTab('refund')}>
                                                                <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                                   style={{borderBottom: aliRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                                            </div>
                                                        </div>
                                                        :
                                                        selected === "nobank" ?
                                                            <div className="user-center ht-60">
                                                                <div className="user-center wd-80"
                                                                     onClick={() => handleNobankAssiTab('charge')}>
                                                                    <p className="user-center c-point wd-50 ht-40 font-s-15"
                                                                       style={{borderBottom: nobankChargeTab ? "solid darkorange" : "none"}}>{t(`st8`)}</p>
                                                                </div>
                                                                <div className="user-center wd-80"
                                                                     onClick={() => handleNobankAssiTab('refund')}>
                                                                    <p className="user-center wd-50 ht-40 font-s-15 c-point"
                                                                       style={{borderBottom: nobankRefundTab ? "solid darkorange" : "none"}}>{t(`st9`)}</p>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                        }
                        <div style={{padding: "10px"}}>
                            {
                                // BtorageGlobal 충전탭
                                selected === "btorageGlobal" && btorageGlobalChargeTab ?
                                    <div>
                                        <div className="user-center">
                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                <p className="font-s-13 m-l-10"
                                                   style={{color: "var(--up-text-sub)"}}>{t(`myBal`)}</p>
                                            </div>
                                            <div className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                <p className="font-s-13 m-l-10" style={{ color: "var(--up-text-sub)"}}>
                                                    {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="user-center">
                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                <p className="font-s-13 m-l-10"
                                                   style={{color: "var(--up-text-sub)"}}>{t(`dcDepPr`)}</p>
                                            </div>
                                            <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                <input onChange={handleBtorageGlobalChargePrice}
                                                       value={btorageGlobalChargePrice}
                                                       className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                       maxLength={25} type="text"
                                                />
                                            </div>
                                        </div>
                                        <div className="user-center">
                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                <p className="font-s-13 m-l-10"
                                                   style={{color: "var(--up-text-sub)"}}>{t(`modExr`)}</p>

                                                {/*통화 셀렉트*/}
                                                <div ref={dollarRef} className="ht-30 wd-55 position-relative m-l-10">
                                                    <button className="selectParentBt wd-100pc ht-100pc"
                                                            onClick={toggleDollarShow}>
                                                        <p className="font-s-12">{selectedDollar}</p>
                                                    </button>
                                                    {dollarShow ?
                                                        <div className="wd-100pc border-thin overflow-y-scroll"
                                                             style={{
                                                                 zIndex: 99,
                                                                 marginTop: "5px",
                                                             }}>
                                                            {btorageDollar.map((dollar, index) => (
                                                                <div
                                                                    className="selectChildBt user-center pd10 c-point font-s-12 border-rd4"
                                                                    key={index}
                                                                    onClick={() => selectChangeDollar(dollar)}
                                                                    style={{
                                                                        zIndex: 99,
                                                                    }}>{dollar}</div>
                                                            ))}
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>
                                            <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                <div className="wd-60pc ht-100pc m-l-10 display-flex align-center">
                                                    <p className="font-s-13 font-c-darkorange fw-bold">
                                                        {Number(btorageGlobalChargePrice.replace(/,/g, "")) > 0 ? btorageGlobalChargeExPrice : null}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="user-center gap8" style={{marginTop: "20px"}}>
                                            <button onClick={btorageGlobalChargeInit}
                                                    className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                            {/*초기화 버튼*/}
                                            <button onClick={openBtorageGlobalPopup}
                                                    className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                            {/*신청 버튼*/}
                                        </div>
                                    </div>
                                    :
                                    // BtorageGlobal 환급탭
                                    selected === "btorageGlobal" && btorageGlobalRefundTab ?
                                        <div>
                                            <div className="user-center">
                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                    <p className="font-s-13 m-l-10"
                                                       style={{color: "var(--up-text-sub)"}}>{t(`myBal`)}</p>
                                                </div>
                                                <div className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                    <p className="font-s-13 m-l-10"
                                                       style={{color: "var(--up-text-sub)"}}>
                                                        {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="user-center">
                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                    <p className="font-s-13 m-l-10"
                                                       style={{color: "var(--up-text-sub)"}}>{t(`dcRfPr`)}</p>
                                                </div>
                                                <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                    <input onChange={handleBtorageGlobalRefundPrice}
                                                           value={btorageGlobalRefundPrice}
                                                           className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                           maxLength={25} type="text"/>
                                                </div>
                                            </div>
                                            <div className="user-center">
                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                    <p className="font-s-13 m-l-10"
                                                       style={{color: "var(--up-text-sub)"}}>{t(`modExr`)}</p>

                                                    {/*통화 셀렉트*/}
                                                    <div ref={dollarRef}
                                                         className="wd-55 ht-30 position-relative m-l-10">
                                                        <button className="selectParentBt wd-100pc ht-100pc"
                                                                onClick={toggleDollarShow}>
                                                            <p className="font-s-12">{selectedDollar}</p>
                                                        </button>
                                                        {dollarShow ?
                                                            <div
                                                                className="wd-100pc border-thin overflow-y-scroll"
                                                                style={{
                                                                    zIndex: 99,
                                                                    marginTop: "5px",
                                                                }}>
                                                                {btorageDollar.map((dollar, index) => (
                                                                    <div
                                                                        className="selectChildBt user-center pd10 c-point font-s-12 border-rd4"
                                                                        key={index}
                                                                        onClick={() => selectChangeDollar(dollar)}
                                                                        style={{zIndex: 99,}}>{dollar}</div>
                                                                ))}
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                    <div className="wd-60pc ht-100pc m-l-10 display-flex align-center">
                                                        <p className="font-s-13 font-c-darkorange fw-bold">
                                                            {Number(btorageGlobalRefundPrice.replace(/,/g, "")) > 0 ? btorageGlobalRefundExPrice : null}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="user-center">
                                                <div className="wd-40pc ht-40 display-flex align-center" style={{
                                                    backgroundColor: "var(--dc-field)",
                                                }}>
                                                    <p className="font-s-13 m-l-10"
                                                       style={{color: "var(--up-text-sub)"}}>{t(`joinLabel1`)}</p>
                                                </div>
                                                <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                    <input
                                                        className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                        onChange={handleBtorageGlobalRefundEmail}
                                                        value={btorageGlobalRefundEmail}
                                                        maxLength={50} type="text"
                                                    />
                                                </div>
                                            </div>
                                            <div className="user-center gap8" style={{marginTop: "20px"}}>
                                                <button onClick={btorageGlobalRefundInit}
                                                        className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                {/*초기화 버튼*/}
                                                <button onClick={saveBtorageGlobalRefund} disabled={submitBtDisabled}
                                                        className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                {/*신청 버튼*/}
                                            </div>
                                        </div>
                                        :
                                        // BtorageKorean 충전탭
                                        selected === "btorageKorean" && btorageKoreanChargeTab ?
                                            <div>
                                                <div className="user-center">
                                                    <div className="wd-40pc ht-40 display-flex align-center"
                                                         style={{backgroundColor: "var(--dc-field)"}}>
                                                        <p className="font-s-13 m-l-10"
                                                           style={{color: "var(--up-text-sub)"}}>{t(`myBal`)}</p>
                                                    </div>
                                                    <div className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                        <p className="font-s-13 m-l-10"
                                                           style={{color: "var(--up-text-sub)"}}>
                                                            {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="user-center">
                                                    <div className="wd-40pc ht-40 display-flex align-center"
                                                         style={{backgroundColor: "var(--dc-field)"}}>
                                                        <p className="font-s-13 m-l-10"
                                                           style={{color: "var(--up-text-sub)"}}>{t(`dcDepPr`)}</p>
                                                    </div>
                                                    <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                        <input onChange={handleBtorageKoreanChargePrice}
                                                               value={btorageKoreanChargePrice}
                                                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                               maxLength={25} type="text"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="user-center gap8" style={{marginTop: "20px"}}>
                                                    <button onClick={btorageKoreanChargeInit}
                                                            className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                    {/*초기화 버튼*/}
                                                    <button onClick={openBtorageKoreanPopup}
                                                            className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                    {/*신청 버튼*/}
                                                </div>
                                            </div>
                                            :
                                            // BtorageKorean 환급탭
                                            selected === "btorageKorean" && btorageKoreanRefundTab ?
                                                <div>
                                                    <div className="user-center">
                                                        <div className="wd-40pc ht-40 display-flex align-center"
                                                             style={{backgroundColor: "var(--dc-field)"}}>
                                                            <p className="font-s-13 m-l-10"
                                                               style={{color: "var(--up-text-sub)"}}>{t(`myBal`)}</p>
                                                        </div>
                                                        <div className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                            <p className="font-s-13 m-l-10"
                                                               style={{color: "var(--up-text-sub)"}}>
                                                                {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="user-center">
                                                        <div className="wd-40pc ht-40 display-flex align-center"
                                                             style={{backgroundColor: "var(--dc-field)"}}>
                                                            <p className="font-s-13 m-l-10"
                                                               style={{color: "var(--up-text-sub)"}}>{t(`dcRfPr`)}</p>
                                                        </div>
                                                        <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                            <input onChange={handleBtorageKoreanRefundPrice}
                                                                   value={btorageKoreanRefundPrice}
                                                                   className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                   maxLength={25} type="text"/>
                                                        </div>
                                                    </div>
                                                    <div className="user-center">
                                                        <div className="wd-40pc ht-40 display-flex align-center"
                                                             style={{
                                                                 backgroundColor: "var(--dc-field)",
                                                             }}>
                                                            <p className="font-s-13 m-l-10"
                                                               style={{
                                                                   color: "var(--up-text-sub)"
                                                               }}>{t(`joinLabel1`)}</p>
                                                        </div>
                                                        <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                            <input
                                                                className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                onChange={handleBtorageKoreanRefundEmail}
                                                                value={btorageKoreanRefundEmail}
                                                                maxLength={50} type="text"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="user-center gap8" style={{marginTop: "20px"}}>
                                                        <button onClick={btorageKoreanRefundInit}
                                                                className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                        {/*초기화 버튼*/}
                                                        <button onClick={saveBtorageKoreanRefund}
                                                                disabled={submitBtDisabled}
                                                                className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                        {/*신청 버튼*/}
                                                    </div>
                                                </div>
                                                :
                                                // GlobalCard 충전탭
                                                selected === "globalCard" && globalCardChargeTab ?
                                                    <div>
                                                        <div className="user-center">
                                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                                <p className="font-s-13 m-l-10" style={{
                                                                    color: "var(--up-text-sub)"
                                                                }}>{t(`myBal`)}</p>
                                                            </div>
                                                            <div
                                                                className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                                <p className="font-s-13 m-l-10"
                                                                   style={{color: "var(--up-text-sub)"}}>
                                                                    {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="user-center">
                                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                                <p className="font-s-13 m-l-10" style={{
                                                                    color: "var(--up-text-sub)"
                                                                }}>{t(`dcDepPr`)}</p>
                                                            </div>
                                                            <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                                <input onChange={handleGlobalCardChargePrice}
                                                                       value={globalCardChargePrice}
                                                                       className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                       maxLength={25} type="text"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="user-center">
                                                            <div className="wd-40pc ht-40 display-flex align-center"
                                                                 style={{backgroundColor: "var(--dc-field)"}}>
                                                                <p className="font-s-13 m-l-10"
                                                                   style={{
                                                                       color: "var(--up-text-sub)"
                                                                   }}>{t(`modExr`)}</p>

                                                                {/*통화 셀렉트*/}
                                                                <div ref={dollarRef}
                                                                     className="ht-30 wd-55 position-relative m-l-10">
                                                                    <button className="selectParentBt wd-100pc ht-100pc"
                                                                            onClick={toggleDollarShow}>
                                                                        <p className="font-s-12">{selectedDollar}</p>
                                                                    </button>
                                                                    {dollarShow ?
                                                                        <div
                                                                            className="wd-100pc border-thin overflow-y-scroll"
                                                                            style={{
                                                                                zIndex: 99,
                                                                                marginTop: "5px",
                                                                            }}>
                                                                            {btorageDollar.map((dollar, index) => (
                                                                                <div
                                                                                    className="selectChildBt user-center pd10 c-point font-s-12 border-rd4"
                                                                                    key={index}
                                                                                    onClick={() => selectChangeDollar(dollar)}
                                                                                    style={{
                                                                                        zIndex: 99,
                                                                                    }}>{dollar}</div>
                                                                            ))}
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="user-input-container wd-60pc ht-35 m-l-10">
                                                                <div
                                                                    className="wd-60pc ht-100pc m-l-10 display-flex align-center">
                                                                    <p className="font-s-13 font-c-darkorange fw-bold">
                                                                        {Number(globalCardChargePrice.replace(/,/g, "")) > 0 ? globalCardChargeExPrice : null}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="user-center gap8" style={{marginTop: "20px"}}>
                                                            {/*초기화 버튼*/}
                                                            <button onClick={globalCardChargeInit}
                                                                    className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                            {/*신청 버튼*/}
                                                            <button onClick={openGlobalCardPopup}
                                                                    className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                        </div>
                                                    </div>
                                                    :
                                                    // GlobalCard 환급탭
                                                    selected === "globalCard" && globalCardRefundTab ?
                                                        <div>
                                                            <div className="user-center">
                                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                                    <p className="font-s-13 m-l-10" style={{
                                                                        color: "var(--up-text-sub)"
                                                                    }}>{t(`myBal`)}</p>
                                                                </div>
                                                                <div
                                                                    className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                                    <p className="font-s-13 m-l-10"
                                                                       style={{color: "var(--up-text-sub)"}}>
                                                                        {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="user-center">
                                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                                    <p className="font-s-13 m-l-10" style={{
                                                                        color: "var(--up-text-sub)"
                                                                    }}>{t(`dcRfPr`)}</p>
                                                                </div>
                                                                <div
                                                                    className="user-input-container wd-60pc ht-35 m-l-10">
                                                                    <input onChange={handleGlobalCardRefundPrice}
                                                                           value={globalCardRefundPrice}
                                                                           className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                           maxLength={25} type="text"/>
                                                                </div>
                                                            </div>
                                                            <div className="user-center">
                                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                                     style={{backgroundColor: "var(--dc-field)"}}>
                                                                    <p className="font-s-13 m-l-10" style={{
                                                                        color: "var(--up-text-sub)"
                                                                    }}>{t(`modExr`)}</p>

                                                                    {/*통화 셀렉트*/}
                                                                    <div ref={dollarRef}
                                                                         className="wd-55 ht-30 position-relative m-l-10">
                                                                        <button
                                                                            className="selectParentBt wd-100pc ht-100pc"
                                                                            onClick={toggleDollarShow}>
                                                                            <p className="font-s-12"
                                                                               style={{margin: "0"}}>{selectedDollar}</p>
                                                                        </button>
                                                                        {dollarShow ?
                                                                            <div
                                                                                className="wd-100pc border-thin overflow-y-scroll"
                                                                                style={{
                                                                                    zIndex: 99,
                                                                                    marginTop: "5px",
                                                                                }}>
                                                                                {btorageDollar.map((dollar, index) => (
                                                                                    <div
                                                                                        className="selectChildBt user-center pd10 c-point font-s-12 border-rd4"
                                                                                        key={index}
                                                                                        onClick={() => selectChangeDollar(dollar)}
                                                                                        style={{zIndex: 99,}}>{dollar}</div>
                                                                                ))}
                                                                            </div>
                                                                            :
                                                                            null
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="user-input-container wd-60pc ht-35 m-l-10">
                                                                    <div
                                                                        className="wd-60pc ht-100pc m-l-10 display-flex align-center">
                                                                        <p className="font-s-13 font-c-darkorange fw-bold">
                                                                            {Number(globalCardRefundPrice.replace(/,/g, "")) > 0 ? globalCardRefundExPrice : null}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="user-center">
                                                                <div className="wd-40pc ht-40 display-flex align-center"
                                                                     style={{
                                                                         backgroundColor: "var(--dc-field)",
                                                                     }}>
                                                                    <p className="font-s-13 m-l-10"
                                                                       style={{
                                                                           color: "var(--up-text-sub)"
                                                                       }}>{t(`joinLabel1`)}</p>
                                                                </div>
                                                                <div
                                                                    className="user-input-container wd-60pc ht-35 m-l-10">
                                                                    <input
                                                                        className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                        onChange={handleGlobalCardRefundEmail}
                                                                        value={globalCardRefundEmail}
                                                                        maxLength={50} type="text"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="user-center gap8"
                                                                 style={{marginTop: "20px"}}>
                                                                {/*초기화 버튼*/}
                                                                <button onClick={globalCardRefundInit}
                                                                        className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                {/*신청 버튼*/}
                                                                <button onClick={saveGlobalCardRefund}
                                                                        disabled={submitBtDisabled}
                                                                        className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                            </div>
                                                        </div>
                                                        :
                                                        // KoreanPay 충전탭
                                                        selected === "koreanPay" && koreanPayChargeTab ?
                                                            <div>
                                                                <div className="user-center">
                                                                    <div
                                                                        className="wd-40pc ht-40 display-flex align-center"
                                                                        style={{backgroundColor: "var(--dc-field)"}}>
                                                                        <p className="font-s-13 m-l-10" style={{
                                                                            color: "var(--up-text-sub)"
                                                                        }}>{t(`myBal`)}</p>
                                                                    </div>
                                                                    <div
                                                                        className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                                        <p className="font-s-13 m-l-10"
                                                                           style={{color: "var(--up-text-sub)"}}>
                                                                            {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="user-center">
                                                                    <div
                                                                        className="wd-40pc ht-40 display-flex align-center"
                                                                        style={{backgroundColor: "var(--dc-field)"}}>
                                                                        <p className="font-s-13 m-l-10" style={{
                                                                            color: "var(--up-text-sub)"
                                                                        }}>{t(`dcDepPr`)}</p>
                                                                    </div>
                                                                    <div
                                                                        className="user-input-container wd-60pc ht-35 m-l-10">
                                                                        <input onChange={handleKoreanPayChargePrice}
                                                                               value={koreanPayChargePrice}
                                                                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                               maxLength={25} type="text"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="user-center gap8"
                                                                     style={{marginTop: "20px"}}>
                                                                    <button onClick={koreanPayChargeInit}
                                                                            className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                    {/*초기화 버튼*/}
                                                                    <button onClick={openKoreanPayPopup}
                                                                            className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                    {/*신청 버튼*/}
                                                                </div>
                                                            </div>
                                                            :
                                                            // KoreanPay 환급탭
                                                            selected === "koreanPay" && koreanPayRefundTab ?
                                                                <div>
                                                                    <div className="user-center">
                                                                        <div
                                                                            className="wd-40pc ht-40 display-flex align-center"
                                                                            style={{backgroundColor: "var(--dc-field)"}}>
                                                                            <p className="font-s-13 m-l-10" style={{
                                                                                color: "var(--up-text-sub)"
                                                                            }}>{t(`myBal`)}</p>
                                                                        </div>
                                                                        <div
                                                                            className="wd-60pc ht-40 m-l-10 display-flex align-center">
                                                                            <p className="font-s-13 m-l-10"
                                                                               style={{color: "var(--up-text-sub)"}}>
                                                                                {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="user-center">
                                                                        <div
                                                                            className="wd-40pc ht-40 display-flex align-center"
                                                                            style={{backgroundColor: "var(--dc-field)"}}>
                                                                            <p className="font-s-13 m-l-10" style={{
                                                                                color: "var(--up-text-sub)"
                                                                            }}>{t(`dcRfPr`)}</p>
                                                                        </div>
                                                                        <div
                                                                            className="user-input-container wd-60pc ht-35 m-l-10">
                                                                            <input
                                                                                onChange={handleKoreanPayRefundPrice}
                                                                                value={koreanPayRefundPrice}
                                                                                className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                                maxLength={25} type="text"/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="user-center">
                                                                        <div
                                                                            className="wd-40pc ht-40 display-flex align-center"
                                                                            style={{
                                                                                backgroundColor: "var(--dc-field)",
                                                                            }}>
                                                                            <p className="font-s-13 m-l-10"
                                                                               style={{
                                                                                   color: "var(--up-text-sub)"
                                                                               }}>{t(`joinLabel1`)}</p>
                                                                        </div>
                                                                        <div
                                                                            className="user-input-container wd-60pc ht-35 m-l-10">
                                                                            <input
                                                                                className="ReviewInput user-input wd-100pc p-l-10 p-r-10 font-s-13"
                                                                                onChange={handleKoreanPayRefundEmail}
                                                                                value={koreanPayRefundEmail}
                                                                                maxLength={50} type="text"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="user-center gap8"
                                                                         style={{marginTop: "20px"}}>
                                                                        <button onClick={koreanPayRefundInit}
                                                                                className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                        {/*초기화 버튼*/}
                                                                        <button onClick={saveKoreanPayRefund}
                                                                                disabled={submitBtDisabled}
                                                                                className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                        {/*신청 버튼*/}
                                                                    </div>
                                                                </div>
                                                                :
                                                                // Paypal 충전탭
                                                                selected === "paypal" && paypalChargeTab ?
                                                                    <div>
                                                                        <div className="user-center">
                                                                            <div style={{
                                                                                width: "40%",
                                                                                backgroundColor: "var(--dc-field)",
                                                                                height: "40px",
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <p style={{
                                                                                    fontSize: "13px",
                                                                                    marginLeft: "10px",
                                                                                    color: "var(--up-text-sub)"
                                                                                }}>{t(`myBal`)}</p>
                                                                            </div>
                                                                            <div style={{
                                                                                width: "60%",
                                                                                height: "40px",
                                                                                marginLeft: "10px",
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <p style={{
                                                                                    fontSize: "13px",
                                                                                    marginLeft: "10px",
                                                                                    color: "var(--up-text-sub)"
                                                                                }}>
                                                                                    {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="user-center">
                                                                            <div style={{
                                                                                width: "40%",
                                                                                backgroundColor: "var(--dc-field)",
                                                                                height: "40px",
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <p style={{
                                                                                    fontSize: "13px",
                                                                                    marginLeft: "10px",
                                                                                    color: "var(--up-text-sub)"
                                                                                }}>{t(`dcDepPr`)}</p>
                                                                            </div>
                                                                            <div
                                                                                className="user-input-container"
                                                                                style={{
                                                                                    width: "60%",
                                                                                    height: "35px",
                                                                                    marginLeft: "10px"
                                                                                }}>
                                                                                <input
                                                                                    onChange={handlePaypalChargePrice}
                                                                                    value={paypalChargePrice}
                                                                                    className="ReviewInput user-input"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        paddingLeft: "10px",
                                                                                        paddingRight: "10px",
                                                                                        fontSize: "13px",
                                                                                    }} maxLength={25}
                                                                                    type="text"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="user-center">
                                                                            <div style={{
                                                                                width: "40%",
                                                                                backgroundColor: "var(--dc-field)",
                                                                                height: "40px",
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <p style={{
                                                                                    fontSize: "13px",
                                                                                    marginLeft: "10px",
                                                                                    color: "var(--up-text-sub)"
                                                                                }}>{t(`pmHeader2`)}</p>

                                                                                {/*페이팔통화 셀렉트*/}
                                                                                <div ref={dollarRef} style={{
                                                                                    height: "30px",
                                                                                    width: "55px",
                                                                                    position: "relative",
                                                                                    marginLeft: "10px"
                                                                                }}>
                                                                                    <button
                                                                                        className="selectParentBt"
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100%"
                                                                                        }}
                                                                                        onClick={toggleDollarShow}>
                                                                                        <p style={{
                                                                                            fontSize: "12px"
                                                                                        }}>{selectedDollar}</p>
                                                                                    </button>
                                                                                    {dollarShow ?
                                                                                        <div style={{
                                                                                            width: "100%",
                                                                                            height: "120px",
                                                                                            border: "solid",
                                                                                            borderWidth: "thin 1px",
                                                                                            borderColor: "var(--up-border-2)",
                                                                                            zIndex: 99,
                                                                                            marginTop: "5px",
                                                                                            overflowY: "scroll",
                                                                                        }}>
                                                                                            {paypalDollar.map((dollar, index) => (
                                                                                                <div
                                                                                                    className="selectChildBt"
                                                                                                    key={index}
                                                                                                    onClick={() => selectChangeDollar(dollar)}
                                                                                                    style={{
                                                                                                        display: "flex",
                                                                                                        padding: "10px",
                                                                                                        justifyContent: "center",
                                                                                                        alignItems: "center",
                                                                                                        cursor: "pointer",
                                                                                                        fontSize: "12px",
                                                                                                        borderRadius: "4px",
                                                                                                        zIndex: 99,
                                                                                                    }}>{dollar}</div>
                                                                                            ))}
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="user-input-container"
                                                                                style={{
                                                                                    width: "60%",
                                                                                    height: "35px",
                                                                                    marginLeft: "10px"
                                                                                }}>
                                                                                <div style={{
                                                                                    width: "60%",
                                                                                    height: "100%",
                                                                                    marginLeft: "10px",
                                                                                    display: "flex",
                                                                                    alignItems: "center"
                                                                                }}>
                                                                                    <p style={{
                                                                                        fontSize: "13px",
                                                                                        color: "darkorange",
                                                                                        fontWeight: "bold"
                                                                                    }}>
                                                                                        {Number(paypalChargePrice.replace(/,/g, "")) > 0 ? paypalChargeExPrice : null}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{padding: "10px 0"}}>
                                                                            <div style={{
                                                                                height: "40px",
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <img style={{
                                                                                    width: "20px",
                                                                                    height: "20px"
                                                                                }}
                                                                                     src={mainNotice}/>
                                                                                <p style={{
                                                                                    marginLeft: "8px"
                                                                                }}>{t('dcTx4')}</p>
                                                                            </div>

                                                                            <div>
                                                    <span style={{
                                                        fontSize: "12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "25px"
                                                    }}>- {t(`dcTx1`)}
                                                        <p onClick={moveToPaypalFaq} style={{
                                                            margin: "0 3px",
                                                            color: "darkorange",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                            fontSize: "12px"
                                                        }}>[{t(`dcTx2`)}]</p>
                                                        <p style={{
                                                            fontSize: "12px",
                                                            color: "var(--up-text)"
                                                        }}>{t(`dcTx3`)}</p>
                                                    </span>
                                                                                <p style={{
                                                                                    fontSize: "12px",
                                                                                    color: "var(--up-text)"
                                                                                }}>- {t(`dcTx6`)}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="user-center gap8"
                                                                             style={{marginTop: "20px"}}>
                                                                            <button onClick={paypalChargeInit}
                                                                                    className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                            {/*초기화 버튼*/}
                                                                            <button onClick={openPaypalPopup}
                                                                                    className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                            {/*신청 버튼*/}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    // Paypal 환급탭
                                                                    selected === "paypal" && paypalRefundTab ?
                                                                            <div>
                                                                                <div className="user-center">
                                                                                    <div style={{
                                                                                        width: "40%",
                                                                                        backgroundColor: "var(--dc-field)",
                                                                                        height: "40px",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            fontSize: "13px",
                                                                                            marginLeft: "10px",
                                                                                            color: "var(--up-text-sub)"
                                                                                        }}>{t(`myBal`)}</p>
                                                                                    </div>
                                                                                    <div style={{
                                                                                        width: "60%",
                                                                                        height: "40px",
                                                                                        marginLeft: "10px",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            fontSize: "13px",
                                                                                            marginLeft: "10px",
                                                                                            color: "var(--up-text-sub)"
                                                                                        }}>
                                                                                            {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="user-center">
                                                                                    <div style={{
                                                                                        width: "40%",
                                                                                        backgroundColor: "var(--dc-field)",
                                                                                        height: "40px",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            fontSize: "13px",
                                                                                            marginLeft: "10px",
                                                                                            color: "var(--up-text-sub)"
                                                                                        }}>{t(`dcRfPr`)}</p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="user-input-container"
                                                                                        style={{
                                                                                            width: "60%",
                                                                                            height: "35px",
                                                                                            marginLeft: "10px"
                                                                                        }}>
                                                                                        <input
                                                                                            onChange={handlePaypalRefundPrice}
                                                                                            value={paypalRefundPrice}
                                                                                            className="ReviewInput user-input"
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                paddingLeft: "10px",
                                                                                                paddingRight: "10px",
                                                                                                fontSize: "13px",
                                                                                            }} maxLength={25}
                                                                                            type="text"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="user-center">
                                                                                    <div style={{
                                                                                        width: "40%",
                                                                                        backgroundColor: "var(--dc-field)",
                                                                                        height: "40px",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            fontSize: "13px",
                                                                                            marginLeft: "10px",
                                                                                            color: "var(--up-text-sub)"
                                                                                        }}>{t(`pmHeader2`)}</p>

                                                                                        {/*페이팔통화 셀렉트*/}
                                                                                        <div ref={dollarRef}
                                                                                             style={{
                                                                                                 height: "30px",
                                                                                                 width: "55px",
                                                                                                 position: "relative",
                                                                                                 marginLeft: "10px"
                                                                                             }}>
                                                                                            <button
                                                                                                className="selectParentBt"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%"
                                                                                                }}
                                                                                                onClick={toggleDollarShow}>
                                                                                                <p style={{
                                                                                                    fontSize: "12px"
                                                                                                }}>{selectedDollar}</p>
                                                                                            </button>
                                                                                            {dollarShow ?
                                                                                                <div style={{
                                                                                                    width: "100%",
                                                                                                    height: "120px",
                                                                                                    border: "solid",
                                                                                                    borderWidth: "thin 1px",
                                                                                                    borderColor: "var(--up-border-2)",
                                                                                                    zIndex: 99,
                                                                                                    marginTop: "5px",
                                                                                                    overflowY: "scroll",
                                                                                                }}>
                                                                                                    {paypalDollar.map((dollar, index) => (
                                                                                                        <div
                                                                                                            className="selectChildBt"
                                                                                                            key={index}
                                                                                                            onClick={() => selectChangeDollar(dollar)}
                                                                                                            style={{
                                                                                                                display: "flex",
                                                                                                                padding: "10px",
                                                                                                                justifyContent: "center",
                                                                                                                alignItems: "center",
                                                                                                                cursor: "pointer",
                                                                                                                fontSize: "12px",
                                                                                                                borderRadius: "4px",
                                                                                                                zIndex: 99,
                                                                                                            }}>{dollar}</div>
                                                                                                    ))}
                                                                                                </div>
                                                                                                :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="user-input-container"
                                                                                        style={{
                                                                                            width: "60%",
                                                                                            height: "35px",
                                                                                            marginLeft: "10px"
                                                                                        }}>
                                                                                        <div style={{
                                                                                            width: "60%",
                                                                                            height: "100%",
                                                                                            marginLeft: "10px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                color: "darkorange",
                                                                                                fontWeight: "bold"
                                                                                            }}>
                                                                                                {Number(paypalRefundPrice.replace(/,/g, "")) > 0 ? paypalRefundExPrice : null}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="user-center">
                                                                                    <div style={{
                                                                                        width: "40%",
                                                                                        backgroundColor: "var(--dc-field)",
                                                                                        height: "40px",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            fontSize: "13px",
                                                                                            marginLeft: "10px",
                                                                                            color: "var(--up-text-sub)"
                                                                                        }}>{t(`dcPpMail`)}</p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="user-input-container"
                                                                                        style={{
                                                                                            width: "60%",
                                                                                            height: "35px",
                                                                                            marginLeft: "10px"
                                                                                        }}>
                                                                                        <input
                                                                                            className="ReviewInput user-input"
                                                                                            onChange={handlePaypalRefundEmail}
                                                                                            value={paypalRefundEmail}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                paddingLeft: "10px",
                                                                                                paddingRight: "10px",
                                                                                                fontSize: "13px",
                                                                                            }} maxLength={50}
                                                                                            type="text"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{padding: "10px 0"}}>
                                                                                    <div
                                                                                        style={{
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                        <img style={{
                                                                                            width: "20px",
                                                                                            height: "20px"
                                                                                        }}
                                                                                             src={mainNotice}
                                                                                             alt=""/>
                                                                                        <p style={{
                                                                                            marginLeft: "8px"
                                                                                        }}>{t(`dcTx4`)}</p>
                                                                                    </div>

                                                                                    <div style={{
                                                                                        fontSize: "12px",
                                                                                        display: "block"
                                                                                    }}>
                                                                                        <p>- {t(`dcTx5`)}</p>
                                                                                        <p>- {t(`dcTx6`)}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="user-center gap8"
                                                                                     style={{marginTop: "20px"}}>
                                                                                    <button
                                                                                        onClick={paypalRefundInit}
                                                                                        className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                    {/*초기화 버튼*/}
                                                                                    <button
                                                                                        onClick={savePaypalRefund}
                                                                                        disabled={submitBtDisabled}
                                                                                        className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                                    {/*신청 버튼*/}
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            // wechatpay 충전탭
                                                                            selected === "wechatpay" && wechatChargeTab ?
                                                                                <div>
                                                                                    <div className="user-center">
                                                                                        <div style={{
                                                                                            width: "40%",
                                                                                            backgroundColor: "var(--dc-field)",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>{t(`myBal`)}</p>
                                                                                        </div>
                                                                                        <div style={{
                                                                                            width: "60%",
                                                                                            height: "40px",
                                                                                            marginLeft: "10px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>
                                                                                                {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="user-center">
                                                                                        <div style={{
                                                                                            width: "40%",
                                                                                            backgroundColor: "var(--dc-field)",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>{t(`dcDepPr`)}</p>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-input-container"
                                                                                            style={{
                                                                                                width: "60%",
                                                                                                height: "35px",
                                                                                                marginLeft: "10px"
                                                                                            }}>
                                                                                            <input
                                                                                                onChange={handleWechatChargePrice}
                                                                                                value={wechatChargePrice}
                                                                                                className="ReviewInput user-input"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    paddingLeft: "10px",
                                                                                                    paddingRight: "10px",
                                                                                                    fontSize: "13px",
                                                                                                }} maxLength={25}
                                                                                                type="text"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="user-center">
                                                                                        <div style={{
                                                                                            width: "40%",
                                                                                            backgroundColor: "var(--dc-field)",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>{t(`dcTx7`)}(CNY)</p>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-input-container"
                                                                                            style={{
                                                                                                width: "60%",
                                                                                                height: "35px",
                                                                                                marginLeft: "10px"
                                                                                            }}>
                                                                                            <div style={{
                                                                                                width: "60%",
                                                                                                height: "100%",
                                                                                                marginLeft: "10px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    color: "darkorange",
                                                                                                    fontWeight: "bold"
                                                                                                }}>
                                                                                                    {Number(wechatChargePrice.replace(/,/g, "")) > 0 ? wechatChargeExPrice : null}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="user-center">
                                                                                        <div style={{
                                                                                            width: "40%",
                                                                                            backgroundColor: "var(--dc-field)",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>{t(`dcTx8`)}ID</p>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-input-container"
                                                                                            style={{
                                                                                                width: "60%",
                                                                                                height: "35px",
                                                                                                marginLeft: "10px"
                                                                                            }}>
                                                                                            <input
                                                                                                onChange={handleWechatChargeSendId}
                                                                                                value={wechatChargeSendId}
                                                                                                className="ReviewInput user-input"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    paddingLeft: "10px",
                                                                                                    paddingRight: "10px",
                                                                                                    fontSize: "13px",
                                                                                                }} maxLength={25}
                                                                                                type="text"
                                                                                                placeholder="Wechat ID"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="user-center">
                                                                                        <div style={{
                                                                                            width: "40%",
                                                                                            backgroundColor: "var(--dc-field)",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <p style={{
                                                                                                fontSize: "13px",
                                                                                                marginLeft: "10px",
                                                                                                color: "var(--up-text-sub)"
                                                                                            }}>{t(`dcTx9`)}</p>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-input-container"
                                                                                            style={{
                                                                                                width: "60%",
                                                                                                height: "35px",
                                                                                                marginLeft: "10px"
                                                                                            }}>
                                                                                            <input
                                                                                                onChange={handleWechatChargeSendDate}
                                                                                                value={wechatChargeSendDate}
                                                                                                className="ReviewInput user-input"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    paddingLeft: "10px",
                                                                                                    paddingRight: "10px",
                                                                                                    fontSize: "13px",
                                                                                                }} maxLength={8}
                                                                                                type="text"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        style={{padding: "10px 0"}}>
                                                                                        <div style={{
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <img style={{
                                                                                                width: "20px",
                                                                                                height: "20px"
                                                                                            }}
                                                                                                 src={mainNotice}/>
                                                                                            <p style={{
                                                                                                marginLeft: "8px"
                                                                                            }}>{t('dcTx4')}</p>
                                                                                        </div>

                                                                                        <div
                                                                                            style={{fontSize: "12px"}}>
                                                            <span>- {t(`dcTx10`)}<span onClick={moveToYuanFaq} style={{
                                                                color: "darkorange",
                                                                fontWeight: "bold",
                                                                cursor: "pointer"
                                                            }}> [{t(`dcTx11`)}]</span>{t(`dcTx3`)}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="user-center gap8"
                                                                                        style={{marginTop: "20px"}}>
                                                                                        <button
                                                                                            onClick={wechatChargeInit}
                                                                                            className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                        {/*초기화 버튼*/}
                                                                                        <button
                                                                                            onClick={saveWechatCharge}
                                                                                            disabled={submitBtDisabled}
                                                                                            className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                                        {/*신청 버튼*/}
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                // wechatpay 환급탭
                                                                                selected === "wechatpay" && wechatRefundTab ?
                                                                                    <div>
                                                                                        <div
                                                                                            className="user-center">
                                                                                            <div style={{
                                                                                                width: "40%",
                                                                                                backgroundColor: "var(--dc-field)",
                                                                                                height: "40px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    marginLeft: "10px",
                                                                                                    color: "var(--up-text-sub)"
                                                                                                }}>{t(`myBal`)}</p>
                                                                                            </div>
                                                                                            <div style={{
                                                                                                width: "60%",
                                                                                                height: "40px",
                                                                                                marginLeft: "10px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    marginLeft: "10px",
                                                                                                    color: "var(--up-text-sub)"
                                                                                                }}>
                                                                                                    {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-center">
                                                                                            <div style={{
                                                                                                width: "40%",
                                                                                                backgroundColor: "var(--dc-field)",
                                                                                                height: "40px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    marginLeft: "10px",
                                                                                                    color: "var(--up-text-sub)"
                                                                                                }}>{t(`dcRfPr`)}</p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-input-container"
                                                                                                style={{
                                                                                                    width: "60%",
                                                                                                    height: "35px",
                                                                                                    marginLeft: "10px"
                                                                                                }}>
                                                                                                <input
                                                                                                    onChange={handleWechatRefundPrice}
                                                                                                    value={wechatRefundPrice}
                                                                                                    className="ReviewInput user-input"
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        paddingLeft: "10px",
                                                                                                        paddingRight: "10px",
                                                                                                        fontSize: "13px",
                                                                                                    }}
                                                                                                    maxLength={25}
                                                                                                    type="text"
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-center">
                                                                                            <div style={{
                                                                                                width: "40%",
                                                                                                backgroundColor: "var(--dc-field)",
                                                                                                height: "40px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    marginLeft: "10px",
                                                                                                    color: "var(--up-text-sub)"
                                                                                                }}>{t(`dcTx7`)}(cny)</p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-input-container"
                                                                                                style={{
                                                                                                    width: "60%",
                                                                                                    height: "35px",
                                                                                                    marginLeft: "10px"
                                                                                                }}>
                                                                                                <div style={{
                                                                                                    width: "70%",
                                                                                                    height: "100%",
                                                                                                    marginLeft: "10px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        color: "darkorange",
                                                                                                        fontWeight: "bold"
                                                                                                    }}>
                                                                                                        {Number(wechatRefundPrice.replace(/,/g, "")) > 0 ? wechatRefundExPrice : null}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-center">
                                                                                            <div style={{
                                                                                                width: "40%",
                                                                                                backgroundColor: "var(--dc-field)",
                                                                                                height: "40px",
                                                                                                display: "flex",
                                                                                                alignItems: "center"
                                                                                            }}>
                                                                                                <p style={{
                                                                                                    fontSize: "13px",
                                                                                                    marginLeft: "10px",
                                                                                                    color: "var(--up-text-sub)"
                                                                                                }}>{t(`dcTx12`)}ID</p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-input-container"
                                                                                                style={{
                                                                                                    width: "60%",
                                                                                                    height: "35px",
                                                                                                    marginLeft: "10px"
                                                                                                }}>
                                                                                                <input
                                                                                                    onChange={handleWechatRefundId}
                                                                                                    value={wechatRefundId}
                                                                                                    className="ReviewInput user-input"
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        paddingLeft: "10px",
                                                                                                        paddingRight: "10px",
                                                                                                        fontSize: "13px",
                                                                                                    }}
                                                                                                    maxLength={25}
                                                                                                    type="text"
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="user-center gap8"
                                                                                            style={{marginTop: "20px"}}>
                                                                                            <button
                                                                                                onClick={wechatRefundInit}
                                                                                                className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                            {/*초기화 버튼*/}
                                                                                            <button
                                                                                                onClick={saveWechatRefund}
                                                                                                disabled={submitBtDisabled}
                                                                                                className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                                            {/*신청 버튼*/}
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    // alipay 충전탭
                                                                                    selected === "alipay" && aliChargeTab ?
                                                                                        <div>
                                                                                            <div
                                                                                                className="user-center">
                                                                                                <div style={{
                                                                                                    width: "40%",
                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>{t(`myBal`)}</p>
                                                                                                </div>
                                                                                                <div style={{
                                                                                                    width: "60%",
                                                                                                    height: "40px",
                                                                                                    marginLeft: "10px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>
                                                                                                        {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-center">
                                                                                                <div style={{
                                                                                                    width: "40%",
                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>{t(`dcDepPr`)}</p>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-input-container"
                                                                                                    style={{
                                                                                                        width: "60%",
                                                                                                        height: "35px",
                                                                                                        marginLeft: "10px"
                                                                                                    }}>
                                                                                                    <input
                                                                                                        onChange={handleAliChargePrice}
                                                                                                        value={aliChargePrice}
                                                                                                        className="ReviewInput user-input"
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            paddingLeft: "10px",
                                                                                                            paddingRight: "10px",
                                                                                                            fontSize: "13px",
                                                                                                        }}
                                                                                                        maxLength={25}
                                                                                                        type="text"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-center">
                                                                                                <div style={{
                                                                                                    width: "40%",
                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>{t(`dcTx7`)}(CNY)</p>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-input-container"
                                                                                                    style={{
                                                                                                        width: "60%",
                                                                                                        height: "35px",
                                                                                                        marginLeft: "10px"
                                                                                                    }}>
                                                                                                    <div style={{
                                                                                                        width: "60%",
                                                                                                        height: "100%",
                                                                                                        marginLeft: "10px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            color: "darkorange",
                                                                                                            fontWeight: "bold"
                                                                                                        }}>
                                                                                                            {Number(aliChargePrice.replace(/,/g, "")) > 0 ? aliChargeExPrice : null}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-center">
                                                                                                <div style={{
                                                                                                    width: "40%",
                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>{t(`dcTx8`)}ID</p>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-input-container"
                                                                                                    style={{
                                                                                                        width: "60%",
                                                                                                        height: "35px",
                                                                                                        marginLeft: "10px"
                                                                                                    }}>
                                                                                                    <input
                                                                                                        onChange={handleAliChargeSendId}
                                                                                                        value={aliChargeSendId}
                                                                                                        className="ReviewInput user-input"
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            paddingLeft: "10px",
                                                                                                            paddingRight: "10px",
                                                                                                            fontSize: "13px",
                                                                                                        }}
                                                                                                        maxLength={25}
                                                                                                        type="text"
                                                                                                        placeholder="Alipay ID"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-center">
                                                                                                <div style={{
                                                                                                    width: "40%",
                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <p style={{
                                                                                                        fontSize: "13px",
                                                                                                        marginLeft: "10px",
                                                                                                        color: "var(--up-text-sub)"
                                                                                                    }}>{t(`dcTx9`)}</p>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-input-container"
                                                                                                    style={{
                                                                                                        width: "60%",
                                                                                                        height: "35px",
                                                                                                        marginLeft: "10px"
                                                                                                    }}>
                                                                                                    <input
                                                                                                        onChange={handleAliChargeSendDate}
                                                                                                        value={aliChargeSendDate}
                                                                                                        className="ReviewInput user-input"
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            paddingLeft: "10px",
                                                                                                            paddingRight: "10px",
                                                                                                            fontSize: "13px",
                                                                                                        }} maxLength={8}
                                                                                                        type="text"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                style={{padding: "10px 0"}}>
                                                                                                <div style={{
                                                                                                    height: "40px",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center"
                                                                                                }}>
                                                                                                    <img style={{
                                                                                                        width: "20px",
                                                                                                        height: "20px"
                                                                                                    }}
                                                                                                         src={mainNotice}/>
                                                                                                    <p style={{
                                                                                                        marginLeft: "8px"
                                                                                                    }}>{t('dcTx4')}</p>
                                                                                                </div>

                                                                                                <div
                                                                                                    style={{fontSize: "12px"}}>
                                                            <span>- {t(`dcTx10`)}<span onClick={moveToYuanFaq} style={{
                                                                color: "darkorange",
                                                                fontWeight: "bold",
                                                                cursor: "pointer"
                                                            }}> [{t(`dcTx11`)}]</span>{t(`dcTx3`)}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                className="user-center gap8"
                                                                                                style={{marginTop: "20px"}}>
                                                                                                <button
                                                                                                    onClick={aliChargeInit}
                                                                                                    className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                                {/*초기화 버튼*/}
                                                                                                <button
                                                                                                    onClick={saveAliCharge}
                                                                                                    disabled={submitBtDisabled}
                                                                                                    className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                                                {/*신청 버튼*/}
                                                                                            </div>
                                                                                        </div>
                                                                                        :
                                                                                        // alipay 환급탭
                                                                                        selected === "alipay" && aliRefundTab ?
                                                                                            <div>
                                                                                                <div
                                                                                                    className="user-center">
                                                                                                    <div style={{
                                                                                                        width: "40%",
                                                                                                        backgroundColor: "var(--dc-field)",
                                                                                                        height: "40px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            marginLeft: "10px",
                                                                                                            color: "var(--up-text-sub)"
                                                                                                        }}>{t(`myBal`)}</p>
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        width: "60%",
                                                                                                        height: "40px",
                                                                                                        marginLeft: "10px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            marginLeft: "10px",
                                                                                                            color: "var(--up-text-sub)"
                                                                                                        }}>
                                                                                                            {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-center">
                                                                                                    <div style={{
                                                                                                        width: "40%",
                                                                                                        backgroundColor: "var(--dc-field)",
                                                                                                        height: "40px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            marginLeft: "10px",
                                                                                                            color: "var(--up-text-sub)"
                                                                                                        }}>{t(`dcRfPr`)}</p>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-input-container"
                                                                                                        style={{
                                                                                                            width: "60%",
                                                                                                            height: "35px",
                                                                                                            marginLeft: "10px"
                                                                                                        }}>
                                                                                                        <input
                                                                                                            onChange={handleAliRefundPrice}
                                                                                                            value={aliRefundPrice}
                                                                                                            className="ReviewInput user-input"
                                                                                                            style={{
                                                                                                                width: "100%",
                                                                                                                paddingLeft: "10px",
                                                                                                                paddingRight: "10px",
                                                                                                                fontSize: "13px",
                                                                                                            }}
                                                                                                            maxLength={25}
                                                                                                            type="text"
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-center">
                                                                                                    <div style={{
                                                                                                        width: "40%",
                                                                                                        backgroundColor: "var(--dc-field)",
                                                                                                        height: "40px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            marginLeft: "10px",
                                                                                                            color: "var(--up-text-sub)"
                                                                                                        }}>{t(`dcTx7`)}(cny)</p>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-input-container"
                                                                                                        style={{
                                                                                                            width: "60%",
                                                                                                            height: "35px",
                                                                                                            marginLeft: "10px"
                                                                                                        }}>
                                                                                                        <div style={{
                                                                                                            width: "70%",
                                                                                                            height: "100%",
                                                                                                            marginLeft: "10px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                color: "darkorange",
                                                                                                                fontWeight: "bold"
                                                                                                            }}>
                                                                                                                {Number(aliRefundPrice.replace(/,/g, "")) > 0 ? aliRefundExPrice : null}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-center">
                                                                                                    <div style={{
                                                                                                        width: "40%",
                                                                                                        backgroundColor: "var(--dc-field)",
                                                                                                        height: "40px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                        <p style={{
                                                                                                            fontSize: "13px",
                                                                                                            marginLeft: "10px",
                                                                                                            color: "var(--up-text-sub)"
                                                                                                        }}>{t(`dcTx12`)}ID</p>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-input-container"
                                                                                                        style={{
                                                                                                            width: "60%",
                                                                                                            height: "35px",
                                                                                                            marginLeft: "10px"
                                                                                                        }}>
                                                                                                        <input
                                                                                                            onChange={handleAliRefundId}
                                                                                                            value={aliRefundId}
                                                                                                            className="ReviewInput user-input"
                                                                                                            style={{
                                                                                                                width: "100%",
                                                                                                                paddingLeft: "10px",
                                                                                                                paddingRight: "10px",
                                                                                                                fontSize: "13px",
                                                                                                            }}
                                                                                                            maxLength={25}
                                                                                                            type="text"
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="user-center gap8"
                                                                                                    style={{marginTop: "20px"}}>
                                                                                                    <button
                                                                                                        onClick={aliRefundInit}
                                                                                                        className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                                    {/*초기화 버튼*/}
                                                                                                    <button
                                                                                                        onClick={saveAliRefund}
                                                                                                        disabled={submitBtDisabled}
                                                                                                        className="bt-btn-B wd-80 ht-40 font-s-13">{t(`dcDoneBt`)}</button>
                                                                                                    {/*신청 버튼*/}
                                                                                                </div>
                                                                                            </div>
                                                                                            :
                                                                                            // 무통장입금 충전탭
                                                                                            selected === "nobank" && nobankChargeTab ?
                                                                                                <div>
                                                                                                    <div
                                                                                                        className="user-center">
                                                                                                        <div style={{
                                                                                                            width: "40%",
                                                                                                            backgroundColor: "var(--dc-field)",
                                                                                                            height: "40px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                marginLeft: "10px",
                                                                                                                color: "var(--up-text-sub)"
                                                                                                            }}>{t(`myBal`)}</p>
                                                                                                        </div>
                                                                                                        <div style={{
                                                                                                            width: "60%",
                                                                                                            height: "40px",
                                                                                                            marginLeft: "10px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                marginLeft: "10px",
                                                                                                                color: "var(--up-text-sub)"
                                                                                                            }}>
                                                                                                                {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-center">
                                                                                                        <div style={{
                                                                                                            width: "40%",
                                                                                                            backgroundColor: "var(--dc-field)",
                                                                                                            height: "40px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                marginLeft: "10px",
                                                                                                                color: "var(--up-text-sub)"
                                                                                                            }}>{t(`dcDepPr`)}</p>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-input-container"
                                                                                                            style={{
                                                                                                                width: "60%",
                                                                                                                height: "35px",
                                                                                                                marginLeft: "10px"
                                                                                                            }}>
                                                                                                            <input
                                                                                                                onChange={handleNobankChargePrice}
                                                                                                                value={nobankChargePrice}
                                                                                                                className="ReviewInput user-input"
                                                                                                                style={{
                                                                                                                    width: "100%",
                                                                                                                    paddingLeft: "10px",
                                                                                                                    paddingRight: "10px",
                                                                                                                    fontSize: "13px",
                                                                                                                }}
                                                                                                                maxLength={25}
                                                                                                                type="text"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-center">
                                                                                                        <div style={{
                                                                                                            width: "40%",
                                                                                                            backgroundColor: "var(--dc-field)",
                                                                                                            height: "40px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                marginLeft: "10px",
                                                                                                                color: "var(--up-text-sub)"
                                                                                                            }}>{t(`dcSd`)}</p>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-input-container"
                                                                                                            style={{
                                                                                                                width: "60%",
                                                                                                                height: "35px",
                                                                                                                marginLeft: "10px"
                                                                                                            }}>
                                                                                                            <input
                                                                                                                onChange={handleNobankChargeSendNm}
                                                                                                                value={nobankChargeSendNm}
                                                                                                                className="ReviewInput user-input"
                                                                                                                style={{
                                                                                                                    width: "100%",
                                                                                                                    paddingLeft: "10px",
                                                                                                                    paddingRight: "10px",
                                                                                                                    fontSize: "13px",
                                                                                                                }}
                                                                                                                maxLength={35}
                                                                                                                type="text"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-center">
                                                                                                        <div style={{
                                                                                                            width: "40%",
                                                                                                            backgroundColor: "var(--dc-field)",
                                                                                                            height: "40px",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <p style={{
                                                                                                                fontSize: "13px",
                                                                                                                marginLeft: "10px",
                                                                                                                color: "var(--up-text-sub)"
                                                                                                            }}>{t(`dcSdDate`)}</p>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-input-container"
                                                                                                            style={{
                                                                                                                width: "60%",
                                                                                                                height: "35px",
                                                                                                                marginLeft: "10px"
                                                                                                            }}>
                                                                                                            <input
                                                                                                                onChange={handleNobankChargeSendDate}
                                                                                                                value={nobankChargeSendDate}
                                                                                                                className="ReviewInput user-input"
                                                                                                                style={{
                                                                                                                    width: "100%",
                                                                                                                    paddingLeft: "10px",
                                                                                                                    paddingRight: "10px",
                                                                                                                    fontSize: "13px",
                                                                                                                }}
                                                                                                                maxLength={8}
                                                                                                                type="text"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="user-center gap8"
                                                                                                        style={{marginTop: "20px"}}>
                                                                                                        <button
                                                                                                            onClick={nobankChargeInit}
                                                                                                            className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                                        {/*초기화 버튼*/}
                                                                                                        <button
                                                                                                            onClick={saveNobankCharge}
                                                                                                            className="bt-btn-B wd-80 ht-40 font-s-13"
                                                                                                            disabled={submitBtDisabled}>{t(`dcDoneBt`)}</button>
                                                                                                        {/*신청 버튼*/}
                                                                                                    </div>
                                                                                                </div>
                                                                                                :
                                                                                                // 무통장입금 환급탭
                                                                                                selected === "nobank" && nobankRefundTab ?
                                                                                                    <div>
                                                                                                        <div
                                                                                                            className="user-center">
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "40%",
                                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                                    height: "40px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>{t(`myBal`)}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "60%",
                                                                                                                    height: "40px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>
                                                                                                                    {memberInfo && memberInfo?.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-center">
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "40%",
                                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                                    height: "40px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>{t(`dcRfPr`)}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className="user-input-container"
                                                                                                                style={{
                                                                                                                    width: "60%",
                                                                                                                    height: "35px",
                                                                                                                    marginLeft: "10px"
                                                                                                                }}>
                                                                                                                <input
                                                                                                                    onChange={handleNobankRefundPrice}
                                                                                                                    value={nobankRefundPrice}
                                                                                                                    className="ReviewInput user-input"
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        paddingLeft: "10px",
                                                                                                                        paddingRight: "10px",
                                                                                                                        fontSize: "13px",
                                                                                                                    }}
                                                                                                                    maxLength={25}
                                                                                                                    type="text"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-center">
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "40%",
                                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                                    height: "40px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>{t(`modNbInfo3`)}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className="user-input-container"
                                                                                                                style={{
                                                                                                                    width: "60%",
                                                                                                                    height: "35px",
                                                                                                                    marginLeft: "10px"
                                                                                                                }}>
                                                                                                                <input
                                                                                                                    onChange={handleNobankRefundNm}
                                                                                                                    value={nobankRefundNm}
                                                                                                                    className="ReviewInput user-input"
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        paddingLeft: "10px",
                                                                                                                        paddingRight: "10px",
                                                                                                                        fontSize: "13px",
                                                                                                                    }}
                                                                                                                    maxLength={35}
                                                                                                                    type="text"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-center">
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "40%",
                                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                                    height: "40px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>{t(`dcBkNm`)}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className="user-input-container"
                                                                                                                style={{
                                                                                                                    width: "60%",
                                                                                                                    height: "35px",
                                                                                                                    marginLeft: "10px"
                                                                                                                }}>
                                                                                                                <input
                                                                                                                    onChange={handleNobankRefundBankNm}
                                                                                                                    value={nobankRefundBankNm}
                                                                                                                    className="ReviewInput user-input"
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        paddingLeft: "10px",
                                                                                                                        paddingRight: "10px",
                                                                                                                        fontSize: "13px",
                                                                                                                    }}
                                                                                                                    maxLength={25}
                                                                                                                    type="text"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-center">
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "40%",
                                                                                                                    backgroundColor: "var(--dc-field)",
                                                                                                                    height: "40px",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center"
                                                                                                                }}>
                                                                                                                <p style={{
                                                                                                                    fontSize: "13px",
                                                                                                                    marginLeft: "10px",
                                                                                                                    color: "var(--up-text-sub)"
                                                                                                                }}>{t(`dcAcctNum`)}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className="user-input-container"
                                                                                                                style={{
                                                                                                                    width: "60%",
                                                                                                                    height: "35px",
                                                                                                                    marginLeft: "10px"
                                                                                                                }}>
                                                                                                                <input
                                                                                                                    onChange={handleNobankRefundAccount}
                                                                                                                    value={nobankRefundAccount}
                                                                                                                    className="ReviewInput user-input"
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        paddingLeft: "10px",
                                                                                                                        paddingRight: "10px",
                                                                                                                        fontSize: "13px",
                                                                                                                    }}
                                                                                                                    maxLength={25}
                                                                                                                    type="text"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="user-center gap8"
                                                                                                            style={{marginTop: "20px"}}>
                                                                                                            <button
                                                                                                                onClick={nobankRefundInit}
                                                                                                                className="bt-btn-A wd-80 ht-40 font-s-13">{t(`dcInitBt`)}</button>
                                                                                                            {/*초기화 버튼*/}
                                                                                                            <button
                                                                                                                onClick={saveNobankRefund}
                                                                                                                className="bt-btn-B wd-80 ht-40 font-s-13"
                                                                                                                disabled={submitBtDisabled}>{t(`dcDoneBt`)}</button>
                                                                                                            {/*신청 버튼*/}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    :
                                                                                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                paypalPopupSt ?
                    <PaypalModal paypalPopupSt={paypalPopupSt} paypalPopupClose={paypalPopupClose}
                                 currency={selectedDollar}
                                 finalPayExpense={paypalChargePrice} lastForPrice={paypalChargeExPrice}
                                 afterOrderProcess={savePaypalCharge}
                                         usageType={PAY_USAGE.DEPOSIT}/>
                    :
                    btorageGlobalPopupSt ?
                        <BtorageGlobalModal btorageGlobalPopupSt={btorageGlobalPopupSt}
                                            closeBtorageGlobalPopup={closeBtorageGlobalPopup}
                                            currency={selectedDollar} mbNum={memberInfo.mbNum}
                                            finalPayExpense={btorageGlobalChargePrice}
                                            lastForPrice={btorageGlobalChargeExPrice}
                                            afterOrderProcess={saveBtorageGlobalCharge}
                                         usageType={PAY_USAGE.DEPOSIT}/>
                        :
                        btorageKoreanPopupSt ?
                            <BtorageKoreanModal btorageKoreanPopupSt={btorageKoreanPopupSt}
                                                closeBtorageKoreanPopup={closeBtorageKoreanPopup}
                                                mbNum={memberInfo.mbNum}
                                                finalPayExpense={btorageKoreanChargePrice}
                                                afterOrderProcess={saveBtorageKoreanCharge}
                                         usageType={PAY_USAGE.DEPOSIT}/>
                            :
                            globalCardPopupSt ?
                                <GlobalCardModal globalCardPopupSt={globalCardPopupSt}
                                                 closeGlobalCardPopup={closeGlobalCardPopup}
                                                    currency={selectedDollar} mbNum={memberInfo.mbNum}
                                                    finalPayExpense={globalCardChargePrice}
                                                    lastForPrice={globalCardChargeExPrice}
                                                    afterOrderProcess={saveGlobalCardCharge}
                                         usageType={PAY_USAGE.DEPOSIT}/>
                                :
                                koreanPayPopupSt ?
                                    <KoreanPayModal koreanPayPopupSt={koreanPayPopupSt}
                                                    closeKoreanPayPopup={closeKoreanPayPopup}
                                                        mbNum={memberInfo.mbNum}
                                                        finalPayExpense={koreanPayChargePrice}
                                                        afterOrderProcess={saveKoreanPayCharge}
                                         usageType={PAY_USAGE.DEPOSIT}/>
                                    :
                                    fieldEmptyError ?
                                        <MsgCheckModal fieldEmptyError={fieldEmptyError}
                                                       closeFieldEmptyError={closeFieldEmptyError}/>
                                        :
                                        /* [결제누락 개선] PG 결제성공 / 예치금 충전저장 실패 안내 */
                                        depositChargeFailMsg ?
                                            <MsgCheckModal depositChargeFailMsg={depositChargeFailMsg}
                                                           closeDepositChargeFailMsg={closeDepositChargeFailMsg}/>
                                            :
                        null
            }
        </div>
    )
}

export default withAuth(UserDepChargePg)
